webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  request: function request(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!method) {
      console.error('API function call requires method argument');
      return;
    }

    if (!uri) {
      console.error('API function call requires uri argument');
      return;
    }

    var url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + uri;
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({ method: method, url: url, data: data });
  },
  authenticatedRequest: function authenticatedRequest(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!method) {
      console.error('API function call requires method argument');
      return;
    }

    if (!uri) {
      console.error('API function call requires uri argument');
      return;
    }

    var url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + uri;
    var headers = { 'Authorization': window.localStorage.getItem('token') };
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({ method: method, url: url, data: data, headers: headers });
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: "https://prod-ukraine-api-backup.cleverapps.io" || 'http://localhost:7000',
  streamingURI: "https://prod-ukraine-media-backup.cleverapps.io" || 'http://localhost:8200',
  domain: "https://backoffice-ukraine.back-up-reporting.com" || 'http://localhost:8080',
  webSocketServer: "wss://prod-ukraine-api-backup.cleverapps.io/websocket" || 'ws://localhost:7000/websocket',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  extractTestimoniesMarkers: function extractTestimoniesMarkers(testimonies) {
    var _this = this;

    var linkToDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var markers = [];
    if (testimonies && testimonies.length) {
      markers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.compact(testimonies.map(function (testimony) {
        return _this.extractTestimonyMarker(testimony, linkToDetails);
      }));
    }
    return markers;
  },
  extractTestimonyMarker: function extractTestimonyMarker(testimony) {
    var linkToDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var longitude = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(testimony, 'victimLocation.geoLocation.coordinates[0]');
    var latitude = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(testimony, 'victimLocation.geoLocation.coordinates[1]');

    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(longitude) && __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(latitude)) {
      var marker = {
        title: 'Testimony #' + testimony.randomId,
        coordinates: { latitude: latitude, longitude: longitude },
        perimeter: null,
        popup: this.buildTestimonyPopupDescription(testimony)
      };

      if (linkToDetails) {
        marker.link = {
          label: 'View details',
          route: {
            name: 'Testimony',
            params: { id: testimony._id || testimony.id }
          }
        };
      }

      return marker;
    } else {
      return null;
    }
  },
  buildTestimonyPopupDescription: function buildTestimonyPopupDescription(testimony) {
    var creationDate = testimony.creationDate ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(testimony.creationDate).format('MM/DD/YYYY HH:mm') : 'Unknown';

    var identity = testimony.fullName;
    if (!identity) {
      var firstname = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(testimony, 'identity.firstName', '');
      var lastname = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(testimony, 'identity.name', '');
      identity = firstname || lastname ? (firstname + ' ' + lastname).trim() : 'Unknown';
    }

    var gender = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(testimony, 'identity.gender', '');
    var genderIcon = void 0;
    switch (gender) {
      case 'MALE':
        genderIcon = 'mars';
        break;
      case 'FEMALE':
        genderIcon = 'venus';
        break;
      default:
        genderIcon = 'genderless';
    }

    var attackDate = null;

    if (testimony.actionPeriod) {
      var startMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(testimony.actionPeriod.startTime);
      var endMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(testimony.actionPeriod.endTime);

      if (startMoment.isSame(endMoment)) {
        attackDate = endMoment.format('MM/DD/YYYY HH:mm');
      } else if (startMoment.isSame(endMoment, 'day')) {
        attackDate = endMoment.format('MM/DD/YYYY') + ' between <br>' + startMoment.format('HH:mm') + ' and ' + endMoment.format('HH:mm');
      } else if (startMoment.isSame(endMoment, 'month')) {
        attackDate = endMoment.format('MMM YYYY') + ' between <br>' + startMoment.format('Qo') + ' and ' + endMoment.format('Qo');
      } else {
        attackDate = 'between ' + startMoment.format('MM/DD/YYYY') + ' and ' + endMoment.format('MM/DD/YYYY');
      }

      if (!testimony.actionPeriod.exactTime && !testimony.actionPeriod.exactDate) {
        attackDate += '&nbsp;<i class="fa fa-exclamation text-danger" title="Estimated time" data-toggle="tooltip" data-placement="top"></i>';
      }
    }

    var hasInjury = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(testimony, 'victimCondition.injury', false);
    var injured = hasInjury ? 'Injured' : 'Not injured';

    return '\n      <strong>Testimony #' + testimony.randomId + '</strong><br>\n      <i class="fa fa-fw fa-clock"></i>&nbsp;' + creationDate + '<br>\n      <i class="fa fa-fw fa-' + genderIcon + '" title="' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.lowerCase(gender)) + '"></i>&nbsp;' + identity + '<br>\n      <br><strong>Attack</strong><br>\n      <i class="fa fa-fw fa-calendar-day"></i>&nbsp;' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.defaultTo(attackDate, '(date not specified)') + '<br>\n      <i class="fa fa-fw fa-user-injured"></i>&nbsp;' + injured + '\n    ';
  }
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["f"] = prettyNumber;
/* harmony export (immutable) */ __webpack_exports__["g"] = prettyArray;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["i"] = age;
/* harmony export (immutable) */ __webpack_exports__["d"] = prettyDateTime;
/* harmony export (immutable) */ __webpack_exports__["e"] = prettyTime;
/* harmony export (immutable) */ __webpack_exports__["h"] = pluralize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyNumber(value) {
  if (value === 'ONE') {
    return 'One';
  } else if (value === 'MORE_THAN_ONE') {
    return 'More than one';
  } else {
    return '';
  }
}

function prettyArray(array) {
  if (array === null) return null;else {
    var lastIndex = array.length - 1;
    return array.map(function (value, ind) {
      if (ind === lastIndex) return '' + value;else return value + ',';
    });
  }
}

function prettyDate(value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('DD/MM/YYYY');
  }
}

function age(value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(value), 'years');
  }
}

function prettyDateTime(value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('DD/MM/YYYY HH:mm');
  }
}

function prettyTime(value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('HH:mm');
  }
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Testimonies_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Testimonies_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Testimonies_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Testimony_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Testimony_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Testimony_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_TestimonyHistory_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_TestimonyHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_TestimonyHistory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Cases_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Cases_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Cases_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Case_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Case_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_Case_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Users_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Users_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_Users_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Password_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Password_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_Password_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Subscriptions_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Subscriptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_Subscriptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Worldmap_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Worldmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_Worldmap_vue__);















var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a,
  name: 'Login'
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default.a,
    name: 'Dashboard',
    meta: {
      description: 'Overview of environment',
      requiresAuth: true
    }
  }, {
    path: 'worldmap',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_Worldmap_vue___default.a,
    name: 'Worldmap',
    meta: {
      description: 'Worldmap testimonies location',
      requiresAuth: true
    }
  }, {
    path: 'testimonies',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Testimonies_vue___default.a,
    name: 'Testimonies',
    meta: {
      description: 'Testimonies management',
      requiresAuth: true
    }
  }, {
    path: 'testimonies/:id',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Testimony_vue___default.a,
    name: 'Testimony',
    meta: {
      description: 'Detail of a testimony',
      requiresAuth: true,
      parentName: 'Testimonies'
    }
  }, {
    path: 'testimonies/:id/history',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_TestimonyHistory_vue___default.a,
    name: 'TestimonyHistory',
    meta: {
      description: 'History of testimony',
      requiresAuth: true,
      parentName: 'Testimonies'
    }
  }, {
    path: 'cases',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_Cases_vue___default.a,
    name: 'Cases',
    meta: {
      description: 'Cases management',
      requiresAuth: true
    }
  }, {
    path: 'cases/:id',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_Case_vue___default.a,
    name: 'Case',
    meta: {
      description: 'Detail of a case',
      requiresAuth: true,
      parentName: 'Cases'
    }
  }, {
    path: 'users',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_Users_vue___default.a,
    name: 'Users',
    meta: {
      description: 'Users management',
      requiresAuth: true
    }
  }, {
    path: 'users/:id/password',
    component: __WEBPACK_IMPORTED_MODULE_10__components_views_Password_vue___default.a,
    name: 'Password',
    meta: {
      description: 'Password management',
      requiresAuth: false
    }
  }, {
    path: 'subscriptions',
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_Subscriptions_vue___default.a,
    name: 'Subscriptions',
    meta: {
      description: 'Subscription management',
      requiresAuth: true
    }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(239);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)
__webpack_require__(367)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)
__webpack_require__(376)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_uploader__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuejs_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_lodash__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_ConfirmModal__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_ConfirmModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_ConfirmModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_LinkCaseModal__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_LinkCaseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_LinkCaseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_LinkTestimonyModal__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_LinkTestimonyModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_LinkTestimonyModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_NewCaseModal__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_NewCaseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_NewCaseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_NewUserModal__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_NewUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_NewUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_SubscriptionModal__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_SubscriptionModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_SubscriptionModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Timeline__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_AutomaticData__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_AutomaticData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_AutomaticData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_WeatherCard__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_WeatherCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_WeatherCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Map__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Injuries__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Injuries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_views_Injuries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_TestimoniesList__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_TestimoniesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_views_TestimoniesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_UsersList__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_UsersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_views_UsersList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_Anchors__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_Anchors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_views_Anchors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Signaletics__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Signaletics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_views_Signaletics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_TagsSearch__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_TagsSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_views_TagsSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuejs_datepicker__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_native_websocket__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_native_websocket__);










































__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('paginate', __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('confirm-modal', __WEBPACK_IMPORTED_MODULE_15__components_views_ConfirmModal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('link-case-modal', __WEBPACK_IMPORTED_MODULE_16__components_views_LinkCaseModal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('link-testimony-modal', __WEBPACK_IMPORTED_MODULE_17__components_views_LinkTestimonyModal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('new-case-modal', __WEBPACK_IMPORTED_MODULE_18__components_views_NewCaseModal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('new-user-modal', __WEBPACK_IMPORTED_MODULE_19__components_views_NewUserModal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('new-subscription-modal', __WEBPACK_IMPORTED_MODULE_20__components_views_SubscriptionModal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('timeline', __WEBPACK_IMPORTED_MODULE_21__components_views_Timeline___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('automatic-data', __WEBPACK_IMPORTED_MODULE_22__components_views_AutomaticData___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('weather-card', __WEBPACK_IMPORTED_MODULE_23__components_views_WeatherCard___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('osm-map', __WEBPACK_IMPORTED_MODULE_24__components_views_Map___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('injuries', __WEBPACK_IMPORTED_MODULE_25__components_views_Injuries___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('testimonies-list', __WEBPACK_IMPORTED_MODULE_26__components_views_TestimoniesList___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('users-list', __WEBPACK_IMPORTED_MODULE_27__components_views_UsersList___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('uploader', __WEBPACK_IMPORTED_MODULE_11_vuejs_uploader___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('anchors', __WEBPACK_IMPORTED_MODULE_28__components_views_Anchors___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('signaletics', __WEBPACK_IMPORTED_MODULE_29__components_views_Signaletics___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('tagsSearch', __WEBPACK_IMPORTED_MODULE_30__components_views_TagsSearch___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('datepicker', __WEBPACK_IMPORTED_MODULE_31_vuejs_datepicker___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('count', __WEBPACK_IMPORTED_MODULE_8__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('domain', __WEBPACK_IMPORTED_MODULE_8__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_8__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('prettyDateTime', __WEBPACK_IMPORTED_MODULE_8__filters__["d" /* prettyDateTime */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('prettyTime', __WEBPACK_IMPORTED_MODULE_8__filters__["e" /* prettyTime */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('prettyNumber', __WEBPACK_IMPORTED_MODULE_8__filters__["f" /* prettyNumber */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('prettyArray', __WEBPACK_IMPORTED_MODULE_8__filters__["g" /* prettyArray */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_8__filters__["h" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('age', __WEBPACK_IMPORTED_MODULE_8__filters__["i" /* age */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_lodash___default.a);



var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_5__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!window.localStorage.getItem('token') || window.localStorage.getItem('token') === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_32_vue_native_websocket___default.a, __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].webSocketServer + '?token=' + window.localStorage.getItem('token'));
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

__WEBPACK_IMPORTED_MODULE_13_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.status === 401) {
    router.push({
      path: '/login'
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__components_App_vue___default.a);
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [],
    notifications: [{ 1: 'test', 2: 'test' }],
    tasks: []
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(lat, lng) {
    var timestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.floor(Date.now() / 1000);

    console.log(timestamp);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('get', '/external-data/weather?lat=' + lat + '&lng=' + lng + '&date=' + timestamp);
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    },
    notifyMe: function notifyMe(id) {
      if (Notification.permission !== 'granted') {
        Notification.requestPermission();
      } else {
        var notification = new Notification('New Testimony', {
          icon: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].domain + '/static/img/wwow-logo-min.png',
          body: 'Alert ! A new testimony has been created'
        });

        notification.onclick = function () {
          window.open(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].domain + '/testimonies/' + id);
        };
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$options.sockets.onmessage = function (data) {
        return _this.notifyMe(data.data);
      };
      if (!Notification) {
        console.log('Desktop notifications not available in your browser. Try Chromium.');
        return;
      }

      if (Notification.permission !== 'granted') {
        Notification.requestPermission();
      }
    });
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hideseek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__Sidebar___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
      },
      user: null,
      notifications: [],
      notificationSize: 0,
      error: '',
      timerId: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userInfo']), {
    demo: function demo() {
      console.log('ROUTE', this.$route);
      return {
        avatar: __webpack_require__(408)
      };
    }
  }),
  methods: {
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    me: function me() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].authenticatedRequest('get', '/users/me').then(function (response) {
        _this.user = {
          role: response.data.role,
          displayName: response.data.firstName + ' ' + response.data.lastName
        };
      }).catch(function (error) {
        console.log(error);
      });
    },
    getNotifications: function getNotifications() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].authenticatedRequest('get', '/testimonies?unreadOnly=true').then(function (response) {
        _this2.notifications = response.data.data;
        _this2.notificationSize = response.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    goTo: function goTo(route, id) {
      this.$router.push({ name: route, params: { id: id } });
    },
    checkTokenTTL: function checkTokenTTL() {
      try {
        var claims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__["a" /* default */])(window.localStorage.getItem('token'));
        if (!__WEBPACK_IMPORTED_MODULE_7_moment___default()(claims.exp * 1000).isAfter(__WEBPACK_IMPORTED_MODULE_7_moment___default()(Date.now()))) {
          this.$router.push('/login');
        }
      } catch (e) {
        this.$router.push('/login');
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.timerId = setInterval(function () {
      _this3.checkTokenTTL();
    }, 60000);
    this.$nextTick(function () {
      if (window.localStorage && window.localStorage.getItem('token')) {
        _this3.me();
        _this3.getNotifications();
      }
    });
  },
  destroyed: function destroyed() {
    clearInterval(this.timerId);
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      username: '',
      password: '',
      response: ''
    };
  },

  methods: {
    checkCreds: function checkCreds() {
      var _this = this;

      var username = this.username,
          password = this.password;


      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].request('post', '/auth/token', { username: username, password: password }).then(function (response) {
        _this.toggleLoading();

        var data = response.data;

        console.log(data);

        if (data.token) {
          var token = 'Bearer ' + data.token;

          _this.$store.commit('SET_TOKEN', token);

          if (window.localStorage) {
            window.localStorage.setItem('token', token);
          }

          _this.$router.push(data.redirect ? data.redirect : '/');
          return;
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        console.log(error);

        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
        _this.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      if (_this2.$route.query.logout && _this2.$route.query.logout === 'yes') {
        _this2.$store.commit('SET_TOKEN', null);
        if (window.localStorage) {
          window.localStorage.removeItem('token');
        }
      }
    });
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl', 'role'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarName',
  props: ['role']
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Anchors',
  props: ['type', 'id', 'version'],
  data: function data() {
    return {
      anchors: []
    };
  },

  methods: {
    getUrl: function getUrl(anchor) {
      var endpoint = void 0;
      if (this.type === 'cases') {
        endpoint = '/cases/' + this.id + '/anchor/' + anchor._id + '?token=' + window.localStorage.getItem('token').substring(7);
      } else {
        endpoint = '/testimonies/' + this.id + '/anchor/' + anchor.version + '?token=' + window.localStorage.getItem('token').substring(7);
      }
      return '' + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + endpoint;
    },
    download: function download(anchorId) {
      console.log('try to download the ZIP file corresponding to the anchor : ' + anchorId);
    },
    confirmAnchor: function confirmAnchor() {
      window.jQuery('#ConfirmAnchorModal').modal({});
    },
    anchor: function anchor() {
      var _this = this;

      var endpoint = void 0;
      if (this.type === 'cases') {
        endpoint = '/cases/' + this.id + '/anchor';
      } else {
        endpoint = '/testimonies/' + this.id + '/anchor/' + this.version;
      }

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('post', endpoint).then(function (response) {
        _this.getAnchors();
        if (_this.type === 'testimonies') {
          _this.$emit('anchorDone', { response: response.data.testimony });
        }
      }).catch(function (error) {
        console.log(error);
        _this.goToReadMode();
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    getAnchors: function getAnchors() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('get', '/' + this.type + '/' + this.id + '/anchor').then(function (response) {
        _this2.anchors = response.data.data;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.getAnchors();
    });
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AutomaticData',
  props: ['testimonyLocation', 'testimonyTime'],
  data: function data() {
    return {
      tweets: []
    };
  },

  methods: {
    getTweets: function getTweets() {
      this.tweets = [{ id: '955173521138823169' }, { id: '955031868373549056' }, { id: '954244683630284801' }, { id: '953030868360196096' }];
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.getTweets();
    });
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_async__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_async__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  data: function data() {
    return {
      firstGlobalEnpoint: '/cases/' + this.$route.params.id + '/testimonies',
      firstSearchEndpoint: '/testimonies/search',
      firstAdditionalQueryParam: '',
      secondGlobalEnpoint: '/testimonies',
      secondSearchEndpoint: '/testimonies/search',
      secondAdditionalQueryParam: '&notInCase=' + this.$route.params.id,
      firstSearchEnabled: false,
      secondSearchEnabled: true,
      id: this.$route.params.id,
      currentCase: null,
      testimonies: [],
      testimoniesMarkers: []
    };
  },

  methods: {
    refresh: function refresh() {
      console.log('refresh');
    },
    getCase: function getCase() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/cases/' + this.id).then(function (response) {
        _this.currentCase = response.data;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    onTestimoniesLoaded: function onTestimoniesLoaded($event) {
      this.testimoniesMarkers = __WEBPACK_IMPORTED_MODULE_3__helper__["a" /* default */].extractTestimoniesMarkers($event, true);
    },
    confirm: function confirm() {
      window.jQuery('#ConfirmModal').modal({});
    },
    archive: function archive() {},
    openLinkModal: function openLinkModal() {
      window.jQuery('#LinkTestimonyModal').modal({});
    },
    linkAll: function linkAll(selectedTestimonies) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_async___default.a.eachOfSeries(selectedTestimonies, this.link, function (err) {
        if (err) console.error(err);
        _this2.getCase();
        _this2.$refs.testimoniesListRef.refresh(true);
      });
    },
    link: function link(selectedTestimony, index, callback) {
      var body = {
        testimonyId: selectedTestimony._id,
        version: selectedTestimony.version
      };
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('post', '/cases/' + this.id + '/testimonies', body).then(function (response) {
        callback();
      }).catch(function (error) {
        console.log(error);
        callback(error);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.getCase();
    });
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a },
  data: function data() {
    return {
      cases: [],
      tagsByCase: {},
      query: null,
      size: 10,
      pageTotal: 0,
      total: 0,
      page: 0,
      sortField: 'creationDate',
      desc: 'true'
    };
  },

  methods: {
    openModal: function openModal() {
      window.jQuery('#NewCaseModal').modal({});
    },
    createCase: function createCase(name) {
      var _this = this;

      console.log('create case with name : ' + name);
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('post', '/cases', { name: name }).then(function (response) {
        _this.refresh(true);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    goToCase: function goToCase(selectedCase) {
      var id = selectedCase._id ? selectedCase._id : selectedCase.id;
      this.$router.push({ name: 'Case', params: { id: id } });
    },
    sortBy: function sortBy(sortField, desc) {
      this.sortField = sortField;
      this.desc = desc;
      this.refresh(true);
    },
    changePage: function changePage(pageNum) {
      this.page = pageNum - 1;
      this.refresh();
    },
    showSizeChange: function showSizeChange(e) {
      this.size = e.target.value;
      this.refresh(true);
    },
    refresh: function refresh() {
      var toFirstPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (toFirstPage) {
        this.page = 0;
      }

      this.getTagsGroupedByCase();
      if (this.$route.query.tag) {
        this.searchByTag(this.$route.query.tag);
      } else if (this.query === null || this.query === '') {
        this.getCases();
      } else {
        this.search(false);
      }
    },
    searchChange: function searchChange(e) {
      this.refresh(true);
    },
    searchByTag: function searchByTag(tagName) {
      var _this2 = this;

      this.$refs['tags-search'].selected = [{ name: tagName }];
      var endpoint = '/cases/search?q=*&size=' + this.size + '&page=0&sortField=' + this.sortField + '&desc=' + this.desc + '&tag=' + tagName;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('get', endpoint).then(function (response) {
        var data = response.data;
        _this2.cases = data.data;
        _this2.total = data.total;
        _this2.pageTotal = Math.ceil(_this2.total / _this2.size);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    },
    search: function search() {
      var _this3 = this;

      var isNewSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isNewSearch) {
        this.page = 0;
      }
      var endpoint = '/cases/search?q=' + (this.query === null || this.query === '' ? '*' : this.query) + '&size=' + this.size + '&page=' + this.page + '&sortField=' + this.sortField + '&desc=' + this.desc;
      this.$refs['tags-search'].selected.forEach(function (tag) {
        endpoint += '&tag=' + tag.name;
      });

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('get', endpoint).then(function (response) {
        var data = response.data;
        _this3.cases = data.data;
        _this3.total = data.total;
        _this3.pageTotal = Math.ceil(_this3.total / _this3.size);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this3.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this3.response = 'Server appears to be offline';
      });
    },
    getCases: function getCases() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('get', '/cases?size=' + this.size + '&page=' + this.page + '&sortField=' + this.sortField + '&desc=' + this.desc).then(function (response) {
        var data = response.data;
        _this4.cases = data.data;
        _this4.total = data.total;
        _this4.pageTotal = Math.ceil(_this4.total / _this4.size);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this4.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this4.response = 'Server appears to be offline';
      });
    },
    getTagsGroupedByCase: function getTagsGroupedByCase() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('get', '/tags?groupBy=caseId').then(function (response) {
        response.data.forEach(function (item) {
          _this5.tagsByCase[item.occurrenceId] = item.tags;
        });
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this5.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this5.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.refresh();
    });
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['message', 'title'],
  name: 'ConfirmModal',
  methods: {
    confirm: function confirm() {
      window.jQuery('#ConfirmModal').modal('hide');
      this.$emit('confirm');
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);








var pluginURL = '/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.min.js';
var mapURL = '/static/js/plugins/jvectormap/jquery-jvectormap-world-mill.js';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      generateRandomNumbers: function generateRandomNumbers(numbers, max, min) {
        var a = [];
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max);
        }
        return a;
      },

      tweets: [],
      total: null,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      testimoniesByMonthValues: [],
      testimoniesByGenderValues: [0, 0],
      cases: null,
      casesCompletedRatio: null,
      markers: []
    };
  },

  methods: {
    onMarkerClick: function onMarkerClick(e, code) {
      if (this.markers[code] && this.markers[code].id) {
        this.$router.push({ name: 'Testimony', params: { id: this.markers[code].id } });
      }
    },
    getTweets: function getTweets() {
      this.tweets = [{ id: '955173521138823169' }, { id: '955031868373549056' }, { id: '954244683630284801' }];
    },
    makeMap: function makeMap() {
      var _this = this;

      window.jQuery.getScript(pluginURL, function () {
        window.jQuery.getScript(mapURL, function () {
          window.jQuery('#world-map-markers').vectorMap({
            map: 'world_mill',
            regionStyle: {
              initial: {
                fill: 'white',
                'fill-opacity': 1,
                stroke: 'rgb(80,80,80)',
                'stroke-width': 0.5,
                'stroke-opacity': 0.5
              },
              hover: {
                'fill-opacity': 0.8,
                cursor: 'pointer'
              },
              selected: {
                fill: 'yellow'
              },
              selectedHover: {}
            },
            backgroundColor: 'transparent',
            zoomOnScroll: false,
            scaleColors: ['#C8EEFF', '#0071A4'],
            normalizeFunction: 'polynomial',
            markerStyle: {
              initial: {
                fill: '#E14253',
                stroke: '#b43442'
              },
              hover: {
                stroke: '#747B83',
                'stroke-width': 1,
                cursor: 'pointer',
                'fill-opacity': 0.8
              }
            },
            markerLabelStyle: {
              initial: {
                'font-family': 'Verdana',
                'font-size': '12',
                'font-weight': 'bold',
                cursor: 'default',
                fill: 'black'
              },
              hover: {
                cursor: 'pointer'
              }
            },
            markers: _this.markers,
            onMarkerClick: _this.onMarkerClick
          });
        });
      });
    },
    getMarkers: function getMarkers() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('get', '/testimonies?size=100&sortField=creationDate&desc=true').then(function (response) {
        var data = response.data;
        _this2.markers = data.data.filter(function (testimony) {
          return testimony && testimony.victimLocation && testimony.victimLocation.geoLocation && testimony.victimLocation.geoLocation.coordinates && testimony.victimLocation.geoLocation.coordinates.length === 2;
        }).map(function (testimony) {
          return {
            latLng: [testimony.victimLocation.geoLocation.coordinates[1], testimony.victimLocation.geoLocation.coordinates[0]],
            name: testimony.actionDetail.actionLocation.zone,
            id: testimony._id
          };
        });

        var testimoniesByMonth = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.groupBy(data.data.filter(function (testimony) {
          return testimony.creationDate != null;
        }), function (testimony) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(testimony.creationDate).format('MMM');
        });
        for (var prop in testimoniesByMonth) {
          if (Object.prototype.hasOwnProperty.call(testimoniesByMonth, prop)) {
            testimoniesByMonth[prop] = testimoniesByMonth[prop].length;
          }
        }
        _this2.months.forEach(function (key, index) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(testimoniesByMonth).includes(key) ? _this2.testimoniesByMonthValues.push(testimoniesByMonth[key]) : _this2.testimoniesByMonthValues.push(0);
        });

        var testimoniesGender = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.groupBy(data.data.filter(function (testimony) {
          return testimony.victimIdentity.gender === 'MALE' || testimony.victimIdentity.gender === 'FEMALE';
        }), function (testimony) {
          return testimony.victimIdentity.gender;
        });
        for (var prop2 in testimoniesGender) {
          if (Object.prototype.hasOwnProperty.call(testimoniesGender, prop2)) {
            testimoniesGender[prop2] = testimoniesGender[prop2].length;
          }
        }

        var summ = (testimoniesGender['MALE'] ? testimoniesGender['MALE'] : 0) + (testimoniesGender['FEMALE'] ? testimoniesGender['FEMALE'] : 0);
        testimoniesGender['MALE'] ? _this2.testimoniesByGenderValues[0] = testimoniesGender['MALE'] * 100 / summ : null;
        testimoniesGender['FEMALE'] ? _this2.testimoniesByGenderValues[1] = testimoniesGender['FEMALE'] * 100 / summ : null;

        _this2.makeMap();
        _this2.total = data.total;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    },
    getCases: function getCases() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('get', '/cases?size=10&sortField=creationDate&desc=true').then(function (response) {
        var data = response.data;
        _this3.cases = data.total;
        var casesCompleted = data.data.filter(function (c) {
          c.status === 'COMPLETED';
        }).length;

        if (_this3.cases !== 0) {
          _this3.casesCompletedRatio = Math.ceil(casesCompleted / data.total * 100);
        } else {
          _this3.casesCompletedRatio = 0;
        }
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this3.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this3.response = 'Server appears to be offline';
      });
    }
  },
  computed: {
    coPilotNumbers: function coPilotNumbers() {
      return this.generateRandomNumbers(12, 100, 2);
    },
    personalNumbers: function personalNumbers() {
      return this.generateRandomNumbers(12, 1000000, 10000);
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.getMarkers();
    var monthValues = this.testimoniesByMonthValues;
    var genderValues = this.testimoniesByGenderValues;
    this.$nextTick(function () {
      var ctx = document.getElementById('trafficBar').getContext('2d');
      var config = {
        type: 'bar',
        data: {
          labels: _this4.months,
          datasets: [{
            label: 'Testimonies',
            backgroundColor: '#E14253',
            borderColor: '#E14253',
            borderWidth: 2,
            data: monthValues
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !_this4.isMobile,
          legend: {
            position: 'bottom',
            display: true
          },
          tooltips: {
            mode: 'label',
            xPadding: 10,
            yPadding: 10,
            bodySpacing: 10
          }
        }
      };

      new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, config);

      var pieChartCanvas = document.getElementById('genderRepartition').getContext('2d');
      var pieConfig = {
        type: 'pie',
        data: {
          labels: ['Men', 'Women'],
          datasets: [{
            data: genderValues,
            backgroundColor: ['#E14253', '#af242a'],
            hoverBackgroundColor: ['#E14253', '#af242a']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !_this4.isMobile,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      };
      new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(pieChartCanvas, pieConfig);
      _this4.getTweets();
      _this4.getCases();
    });
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FilePreviewer',
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    source: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isDisplaying: false,
      images: ['.jpg', '.jpeg', '.png'],
      videos: ['.mp4'],
      audios: ['.mp3', '.wav']
    };
  },

  methods: {
    getStream: function getStream() {
      return __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].streamingURI + '/' + this.id + '/' + this.name + '?token=' + window.localStorage.getItem('token').substring(7);
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gridpaint__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gridpaint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gridpaint__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['victimCondition'],
  data: function data() {
    var woundLocations = this.victimCondition ? this.victimCondition.woundLocations : null;
    var backWoundLocations = this.victimCondition ? this.victimCondition.backWoundLocations : null;
    return {
      frontWounds: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.compact(woundLocations),
      backWounds: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.compact(backWoundLocations)
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.loadFrontInjuries();
      _this.loadBackInjuries();
    });
  },

  methods: {
    loadFrontInjuries: function loadFrontInjuries() {
      var target = document.getElementsByClassName('gridpixel-front')[0];
      if (target) {
        this.loadGridInjuries(target, this.frontWounds);
      }
    },
    loadBackInjuries: function loadBackInjuries() {
      var target = document.getElementsByClassName('gridpixel-back')[0];
      if (target) {
        this.loadGridInjuries(target, this.backWounds);
      }
    },
    loadGridInjuries: function loadGridInjuries(targetDOMElement, injuries) {

      var painter = new __WEBPACK_IMPORTED_MODULE_1_gridpaint___default.a({ width: 7, height: 10, cellWidth: 20, cellHeight: 20 });
      painter.background = false;
      painter.grid = false;
      painter.gridColour = '#F8AC3D';
      painter.palette = ['transparent', 'rgba(248, 172, 61, 0.8)'];
      painter.colour = 1;
      painter.tool = 'pencil';
      painter.applyTool(true);

      var canvasContainer = document.createElement('div');
      canvasContainer.appendChild(painter.dom);
      canvasContainer.style.marginBottom = '15px';
      canvasContainer.style.marginTop = '25px';
      canvasContainer.style.overflowX = 'auto';
      targetDOMElement.appendChild(canvasContainer);

      var canvas = canvasContainer.getElementsByTagName('canvas')[0];
      canvas.style.background = 'url(/static/img/gugus.png) center center / contain no-repeat';

      canvas.style.width = '100%';
      canvas.style.height = 'auto';

      var containerStyle = window.getComputedStyle(canvasContainer);
      var availableHeight = canvasContainer.offsetHeight + parseInt(containerStyle.marginTop) + parseInt(containerStyle.marginBottom);
      canvas.style['max-width'] = canvas.width / canvas.height * availableHeight + 'px';

      injuries.forEach(function (w) {
        var xCoord = w.x;
        var yCoord = w.y;
        painter.painting[yCoord][xCoord] = 1;
        painter.action();
      });

      painter.init();
      painter.drawing = false;
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['preselected'],
  name: 'LinkCaseModal',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
  data: function data() {
    return {
      selected: null,
      cases: []
    };
  },

  methods: {
    link: function link() {
      window.jQuery('#LinkCaseModal').modal('hide');
      this.$emit('link', this.selected);
      this.selected = [];
    },
    removeLinkedCases: function removeLinkedCases() {
      var _this = this;

      this.cases = this.cases.filter(function (c) {
        return !_this.preselected.some(function (p) {
          return p._id === c._id;
        });
      });
      console.log(this.cases);
    },
    customLabel: function customLabel(option) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(option.creationDate).format('DD/MM/YYYY') + ' - ' + option.name;
    },
    getCases: function getCases() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].authenticatedRequest('get', '/cases?size=100').then(function (response) {
        _this2.cases = response.data.data;
        return _this2.cases;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.getCases();
    });
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['preselected'],
  name: 'LinkTestimonyModal',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
  data: function data() {
    return {
      selected: null,
      testimonies: []
    };
  },

  methods: {
    link: function link() {
      window.jQuery('#LinkTestimonyModal').modal('hide');
      this.$emit('link', this.selected);
      this.selected = [];
    },
    removeLinkedTestimonies: function removeLinkedTestimonies() {
      var _this = this;

      this.testimonies = this.testimonies.filter(function (c) {
        return !_this.preselected.some(function (p) {
          return p._id === c._id;
        });
      });
      console.log(this.testimonies);
    },
    customLabel: function customLabel(option) {
      var label = '' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(option.creationDate).format('DD/MM/YYYY');
      if (option.actionDetail && option.actionDetail.actionLocation && option.actionDetail.actionLocation.zone) {
        label = label + (' - ' + option.actionDetail.actionLocation.zone);
        if (option.victimIdentity && option.victimIdentity.name) {
          label = label + (' - ' + option.victimIdentity.name);
        }
      } else if (option.victimIdentity && option.victimIdentity.name) {
        label = label + (' - ' + option.victimIdentity.name);
      }

      return label;
    },
    getTestimonies: function getTestimonies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].authenticatedRequest('get', '/testimonies?size=100').then(function (response) {
        _this2.testimonies = response.data.data;
        return _this2.testimonies;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.getTestimonies();
    });
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(19);






var LEAFLET_URL = '/static/js/plugins/leaflet/leaflet.js';
var LEAFLET_AREA_URL = '/static/js/plugins/leaflet/leaflet-areaselect.js';
var LEAFLET_SEARCH_URL = '/static/js/plugins/leaflet/leaflet-search.js';
var DOM_TARGET_ID = 'osm';

var L = void 0;
var map = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['markers', 'search', 'filters', 'noEmptyMessage'],
  data: function data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      lMarkers: [],
      cMarkers: [],
      startDate: null,
      endDate: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initMap();
    });
  },

  methods: {
    initMap: function initMap() {
      var _this2 = this;

      var that = this;

      window.jQuery.getScript(LEAFLET_URL, function () {
        window.jQuery.getScript(LEAFLET_AREA_URL, function () {
          window.jQuery.getScript(LEAFLET_SEARCH_URL, function () {
            L = window.L;

            if (!L.DomUtil.get(DOM_TARGET_ID)) {
              return;
            }

            map = L.map(DOM_TARGET_ID, {
              maxBounds: L.latLngBounds([[-90, -360], [90, 360]]),
              maxBoundsViscosity: 1.0,
              worldCopyJump: true,
              zoomControl: false,
              minZoom: 1
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
              zoom: 18
            }).addTo(map);

            if (_this2.filters) {
              _this2.addFiltersControl(L, map, _this2.filterTestimonies);
            }

            map.addControl(L.control.zoom({ position: 'topleft' }));

            if (_this2.search) {
              map.addControl(new L.Control.Search({
                url: 'https://nominatim.openstreetmap.org/search?q={s}&format=json&addressdetails=0&language=english',
                textPlaceholder: 'Search place...',
                position: 'topleft',
                propertyName: 'display_name',
                propertyLoc: ['lat', 'lon'],
                marker: {
                  icon: new L.Icon({ iconUrl: '/static/css/leaflet/images/marker-icon-red.png' }),
                  circle: null
                },
                hideMarkerOnCollapse: true,
                autoType: false,
                minLength: 3,
                zoom: 12
              }));
            }

            L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png?lang=en', {
              'id': 'wikimedia-tiles',
              'type': 'raster',
              'tileSize': 256
            }).addTo(map);

            if (that.markers && that.markers.length) {
              _this2.addRelocateControl(L, map, _this2.fitToMarkers);

              that.markers.forEach(function (marker) {
                var lMarker = L.marker(L.latLng(marker.coordinates.latitude, marker.coordinates.longitude), {
                  title: marker.title || ''
                });

                lMarker.addTo(map);
                that.lMarkers.push(lMarker);

                if (marker.perimeter) {
                  var cMarker = L.circle(L.latLng(marker.coordinates.latitude, marker.coordinates.longitude), {
                    color: '#2070b7',
                    opacity: 0.7,
                    weight: 2,
                    fillColor: '#2b82cb',
                    fillOpacity: 0.2,
                    radius: marker.perimeter
                  });
                  cMarker.addTo(map);
                  that.cMarkers.push(cMarker);
                }

                if (marker.popup) {
                  var popupContent = marker.popup;
                  if (marker.link) {
                    window.goTo = function (context) {
                      var route = {
                        name: context.getAttribute('data-route'),
                        params: {}
                      };

                      context.getAttributeNames().filter(function (attr) {
                        return attr.startsWith('data-params-');
                      }).forEach(function (paramAttribute) {
                        route.params[paramAttribute.substring('data-params-'.length)] = context.getAttribute(paramAttribute);
                      });

                      that.$router.push(route);
                    };

                    var linkButton = L.DomUtil.create('button', 'btn btn-xs btn-block btn-link');
                    linkButton.type = 'button';
                    linkButton.innerHTML = marker.link.label;
                    linkButton.setAttribute('onclick', 'goTo(this)');
                    linkButton.setAttribute('data-route', marker.link.route.name);
                    for (var param in marker.link.route.params) {
                      if (marker.link.route.params.hasOwnProperty(param)) {
                        linkButton.setAttribute('data-params-' + param, marker.link.route.params[param]);
                      }
                    }

                    popupContent += '<br>' + linkButton.outerHTML;
                  }
                  lMarker.bindPopup(popupContent);
                }
              });

              _this2.fitToMarkers();
            } else {
              map.setView(L.latLng(35, 0), 3);
            }
          });
        });
      });
    },
    addFiltersControl: function addFiltersControl(L, map, callback) {
      L.Control.Filter = L.Control.extend({
        onAdd: function onAdd(map) {
          var div = L.DomUtil.create('div', 'leaflet-control-filters leaflet-bar');

          var fromContainer = document.createElement('div');
          fromContainer.className = 'filter from-date';
          var fromLabel = document.createElement('label');
          fromLabel.textContent = 'From';
          var fromInput = document.createElement('input');
          fromInput.className = 'form-control';
          fromInput.type = 'date';

          fromContainer.appendChild(fromLabel);
          fromContainer.appendChild(fromInput);

          var toContainer = document.createElement('div');
          toContainer.className = 'filter to-date';
          var toLabel = document.createElement('label');
          toLabel.textContent = 'To';
          var toInput = document.createElement('input');
          toInput.className = 'form-control';
          toInput.type = 'date';

          toContainer.appendChild(toLabel);
          toContainer.appendChild(toInput);

          var searchButton = document.createElement('button');
          searchButton.className = 'btn btn-primary';
          searchButton.type = 'button';
          searchButton.innerHTML = '<i class="fa fa-search"></i>';

          div.appendChild(fromContainer);
          div.appendChild(toContainer);
          div.appendChild(searchButton);

          L.DomEvent.addListener(searchButton, 'click', L.DomEvent.stopPropagation).addListener(searchButton, 'click', L.DomEvent.preventDefault).addListener(searchButton, 'click', function () {
            callback({
              startDate: fromInput.value,
              endDate: toInput.value
            });
          });

          return div;
        },

        onRemove: function onRemove(map) {}
      });
      L.control.filter = function (opts) {
        return new L.Control.Filter(opts);
      };
      L.control.filter({ position: 'topleft' }).addTo(map);
    },
    addRelocateControl: function addRelocateControl(L, map, callback) {
      var markerIcon = this.search ? 'fa-globe' : 'fa-map-marker-alt';

      L.Control.Relocate = L.Control.extend({
        onAdd: function onAdd() {
          var div = L.DomUtil.create('div', 'leaflet-bar');
          L.DomUtil.create('a', 'leaflet-control-rencenter fa ' + markerIcon + ' fa-lg', div);

          L.DomEvent.addListener(div, 'click', L.DomEvent.stopPropagation).addListener(div, 'click', L.DomEvent.preventDefault).addListener(div, 'click', callback);

          return div;
        },

        onRemove: function onRemove(map) {}
      });

      var control = new L.Control.Relocate({ position: 'topleft' });
      control.addTo(map);
    },
    filterTestimonies: function filterTestimonies(data) {
      var that = this;
      var params = [];

      var startMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.startDate, 'YYYY-MM-DD');
      if (startMoment.isValid()) {
        params.push('startDate=' + startMoment.format('MM/DD/YYYY'));
      }

      var endMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.endDate, 'YYYY-MM-DD');
      if (endMoment.isValid()) {
        params.push('endDate=' + endMoment.format('MM/DD/YYYY'));
      }

      var query = params.length ? '?' + params.join('&') : '';

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('GET', '/testimonies/all' + query).then(function (response) {
        var testimonies = response.data;

        for (var i = 0; i < that.lMarkers.length; i++) {
          map.removeLayer(that.lMarkers[i]);
        }
        that.lMarkers = [];

        for (var _i = 0; _i < that.cMarkers.length; _i++) {
          map.removeLayer(that.cMarkers[_i]);
        }
        that.cMarkers = [];

        console.log(testimonies);
        var searchMarkers = __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].extractTestimoniesMarkers(testimonies.data, true);
        console.log(searchMarkers);

        searchMarkers.forEach(function (marker) {
          var lMarker = L.marker(L.latLng(marker.coordinates.latitude, marker.coordinates.longitude), {
            title: marker.title || ''
          });

          lMarker.addTo(map);
          that.lMarkers.push(lMarker);

          if (marker.perimeter) {
            var cMarker = L.circle(L.latLng(marker.coordinates.latitude, marker.coordinates.longitude), {
              color: '#2070b7',
              opacity: 0.5,
              weight: 2,
              fillColor: '#2b82cb',
              fillOpacity: 0.1,
              radius: marker.perimeter
            });
            cMarker.addTo(map);
            that.cMarkers.push(cMarker);
          }

          if (marker.popup) {
            var popupContent = marker.popup;
            if (marker.link) {
              window.goTo = function (context) {
                var route = {
                  name: context.getAttribute('data-route'),
                  params: {}
                };

                context.getAttributeNames().filter(function (attr) {
                  return attr.startsWith('data-params-');
                }).forEach(function (paramAttribute) {
                  route.params[paramAttribute.substring('data-params-'.length)] = context.getAttribute(paramAttribute);
                });

                that.$router.push(route);
              };

              var linkButton = L.DomUtil.create('button', 'btn btn-xs btn-block btn-link');
              linkButton.type = 'button';
              linkButton.innerHTML = marker.link.label;
              linkButton.setAttribute('onclick', 'goTo(this)');
              linkButton.setAttribute('data-route', marker.link.route.name);
              for (var param in marker.link.route.params) {
                if (marker.link.route.params.hasOwnProperty(param)) {
                  linkButton.setAttribute('data-params-' + param, marker.link.route.params[param]);
                }
              }

              popupContent += '<br>' + linkButton.outerHTML;
            }
            lMarker.bindPopup(popupContent);
          }
        });
      });
    },
    fitToMarkers: function fitToMarkers() {
      if (!map || !this.markers || !this.markers.length) {
        return;
      }

      var latLngs = void 0;
      if (this.markers.length > 1) {
        latLngs = this.markers.map(function (marker) {
          return [marker.coordinates.latitude, marker.coordinates.longitude];
        });
      } else if (this.markers.length === 1) {
        var coord = this.markers[0].coordinates;
        var offset = 0.25;
        latLngs = [L.latLng(coord.latitude + offset, coord.longitude + offset), L.latLng(coord.latitude - offset, coord.longitude - offset)];
      }

      var latLngBounds = L.latLngBounds(latLngs).pad(0.1);
      map.fitBounds(latLngBounds);
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewCaseModal',
  data: function data() {
    return {
      name: null,
      errors: {
        name: false
      }
    };
  },

  methods: {
    create: function create() {
      if (this.name !== null && this.name !== '') {
        this.errors.name = false;
        window.jQuery('#NewCaseModal').modal('hide');
        this.$emit('create', this.name);
        this.name = null;
      } else {
        this.errors.name = true;
      }
      console.log(this.errors);
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewCaseModal',
  data: function data() {
    return {
      user: {
        username: null,
        firstName: null,
        lastName: null,
        role: 'WWOW_USER'
      }
    };
  },

  validations: {
    user: {
      username: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
      },
      firstName: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      lastName: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    create: function create() {
      this.$v.user.$touch();
      if (!this.$v.user.$invalid) {
        window.jQuery('#NewUserModal').modal('hide');
        this.$emit('create', this.user);
        this.$v.user.$reset();
        this.user = {
          username: null,
          firstName: null,
          lastName: null,
          role: 'WWOW_USER'
        };
      }
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  data: function data() {
    return {
      previousPassword: null,
      password: null,
      confirmPassword: null
    };
  },

  computed: {
    isCreation: function isCreation() {
      return true;
    }
  },
  validations: {
    previousPassword: {
      required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["requiredUnless"])(function (model) {
        return this.isCreation;
      })
    },
    password: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
    confirmPassword: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password') }
  },
  methods: {
    savePassword: function savePassword() {
      var _this = this;

      this.$v.$touch();
      if (this.$route.query.token && !this.$v.$invalid) {
        if (this.isCreation) {
          var body = {
            token: this.$route.query.token,
            password: this.password,
            confirmPassword: this.confirmPassword
          };
          return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].request('post', '/users/' + this.$route.params.id + '/password', body).then(function (response) {
            _this.$router.push({ path: '/login' });
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Signaletics',
  props: ['id', 'type', 'status'],
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a },
  data: function data() {
    var options = [];
    switch (this.type) {
      case 'testimonies':
        options = ['READ', 'UNREAD', 'PROCESSING', 'PROCESSED'];
        break;
      case 'cases':
        options = ['INITIATED', 'CLOSED', 'ANCHORED', 'DELETED'];
        break;
    }
    return {
      tagOptions: [],
      selectedTags: [],
      associatedTags: [],
      selectedStatus: this.status,
      statusOptions: options
    };
  },

  methods: {
    getTags: function getTags() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].authenticatedRequest('get', '/tags').then(function (response) {
        _this.tagOptions = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.differenceWith(response.data.data, _this.associatedTags, function (t1, t2) {
          return t1.name === t2.name;
        });
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    getAssociatedTags: function getAssociatedTags() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].authenticatedRequest('get', '/' + this.type + '/' + this.id + '/tags').then(function (response) {
        _this2.associatedTags = response.data;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      }).finally(function () {
        _this2.getTags();
      });
    },
    saveTags: function saveTags() {
      var _this3 = this;

      var requests = this.selectedTags.map(function (tag) {
        return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].authenticatedRequest('post', '/tags', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
          name: tag.name
        }, _this3.type === 'cases' ? 'caseId' : 'testimonyId', _this3.id));
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(requests).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this3.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this3.response = 'Server appears to be offline';
      }).finally(function () {
        _this3.getAssociatedTags();
        _this3.selectedTags = [];
      });
    },
    saveStatus: function saveStatus(event) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].authenticatedRequest('put', '/' + this.type + '/' + this.id + '/status', {
        status: event.target.value
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this4.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this4.response = 'Server appears to be offline';
      });
    },
    removeTag: function removeTag(tag) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].authenticatedRequest('delete', '/tags/' + tag.name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.type === 'cases' ? 'caseId' : 'testimonyId', this.id)).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this5.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this5.response = 'Server appears to be offline';
      }).finally(function () {
        _this5.getAssociatedTags();
      });
    },
    searchTag: function searchTag(tagName) {
      var routeName = null;
      switch (this.type) {
        case 'testimonies':
          routeName = 'Testimonies';
          break;
        case 'cases':
          routeName = 'Cases';
          break;
      }

      if (routeName) {
        this.$router.push({ name: routeName, query: { tag: tagName } });
      }
    },
    optionLabelFormatter: function optionLabelFormatter(option) {
      return option.name + ' (' + (option.count || '0') + ')';
    },
    tagNameConverter: function tagNameConverter(name) {
      var tag = { name: name };
      this.tagOptions.push(tag);
      this.selectedTags.push(tag);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.getAssociatedTags();
    });
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);






var leafletURL = '/static/js/plugins/leaflet/leaflet.js';
var leafletAreaURL = '/static/js/plugins/leaflet/leaflet-areaselect.js';

var map = void 0;
var areaSelect = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubscriptionModal',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a },
  data: function data() {
    return {
      isUpdate: false,
      subscriptionForUpdate: null,
      name: null,
      frequency: null,
      emails: [],
      emailsOptions: [],
      area: {
        center: null,
        northEast: null,
        southWest: null,
        zoom: null,
        size: null
      },
      errors: {
        name: null,
        frequency: null,
        emails: null,
        area: null
      }
    };
  },

  methods: {
    init: function init(subscription) {
      this.isUpdate = !!subscription;
      this.editedSubscription = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(subscription);

      this.name = subscription ? subscription.name : null;
      this.frequency = subscription ? subscription.frequency : null;
      this.emails = subscription ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(subscription.emails) : [];
      this.emailsOptions = subscription ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(subscription.emails) : [];
      this.area = subscription ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(subscription.area) : {
        center: null,
        northEast: null,
        southWest: null,
        zoom: null,
        size: null
      };
    },
    initMap: function initMap() {
      var that = this;

      window.jQuery.getScript(leafletURL, function () {
        window.jQuery.getScript(leafletAreaURL, function () {
          var L = window.L;
          var domTargetID = 'lmap';

          if (map && L.DomUtil.get(domTargetID).hasChildNodes()) {
            map.invalidateSize();
          } else {
            map = L.map(domTargetID, {
              maxBounds: L.latLngBounds([[-90, -360], [90, 360]]),
              worldCopyJump: true,
              minZoom: 1
            });
          }

          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 18
          }).addTo(map);

          if (areaSelect) {
            areaSelect.off('change');
            areaSelect.remove();
          }

          if (that.isUpdate) {
            map.setView(L.latLng(that.area.center[1], that.area.center[0]), that.area.zoom);
            areaSelect = L.areaSelect({
              width: that.area.size[0],
              height: that.area.size[1],
              keepAspectRatio: false
            });
          } else {
            map.setView([45, 0], 1);
            areaSelect = L.areaSelect({
              width: 450,
              height: 300,
              keepAspectRatio: false
            });
          }

          areaSelect.on('change', function () {
            var bounds = this.getBounds();
            var center = map.getCenter();
            that.area = {
              center: [center.lng, center.lat],
              northEast: [bounds._northEast.lng, bounds._northEast.lat],
              southWest: [bounds._southWest.lng, bounds._southWest.lat],
              zoom: map.getZoom(),
              size: [areaSelect._width, areaSelect._height]
            };
          });

          areaSelect.addTo(map);
        });
      });
    },
    create: function create() {
      var _this = this;

      this.clearErrors();
      if (!this.preValidate()) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('POST', '/notifications', {
        name: this.name,
        emails: this.emails,
        frequency: this.frequency,
        area: this.area
      }).then(function () {
        return _this.close();
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    update: function update() {
      var _this2 = this;

      this.clearErrors();
      if (!this.preValidate()) {
        return;
      }

      var data = {};
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(this.name, this.editedSubscription.name)) {
        data.name = this.name;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(this.emails, this.editedSubscription.emails)) {
        data.emails = this.emails;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(this.frequency, this.editedSubscription.frequency)) {
        data.frequency = this.frequency;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(this.area.northEast, this.editedSubscription.area.northEast) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(this.area.southWest, this.editedSubscription.area.southWest)) {
        data.area = this.area;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(data).length) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('PUT', '/notifications/' + this.editedSubscription._id, data).then(function () {
          return _this2.close();
        }).catch(function (error) {
          console.log(error);
          if (error.response.status === 401) {
            _this2.response = 'Username/Password incorrect. Please try again.';
            return;
          }
          _this2.response = 'Server appears to be offline';
        });
      } else {
        this.close();
      }
    },
    remove: function remove() {
      this.$emit('remove', this.editedSubscription._id);
    },
    clearErrors: function clearErrors() {
      this.errors = {
        name: null,
        frequency: null,
        emails: null,
        area: null
      };
    },
    preValidate: function preValidate() {
      this.normalizeCoordinates();

      var validFrequency = !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNil(this.frequency);
      var validEmails = !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(this.emails);
      var validArea = this.isValidLongitude(this.area.northEast[0]) && this.isValidLongitude(this.area.southWest[0]) && this.isValidLatitude(this.area.northEast[1]) && this.isValidLatitude(this.area.southWest[1]);

      if (!validFrequency) {
        this.errors.frequency = 'The frequency must be specified';
      }
      if (!validEmails) {
        this.errors.emails = 'At least one email must be specified';
      }
      if (!validArea) {
        this.errors.area = 'Area coordinates are not valid';
      }

      return !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.compact(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.values(this.errors)).length;
    },
    normalizeCoordinates: function normalizeCoordinates() {
      if (this.area.northEast[0] > 180.0) {
        this.area.northEast[0] -= 360.0;
      }

      if (this.area.southWest[0] < -180.0) {
        this.area.southWest[0] += 360.0;
      }
    },
    isValidLongitude: function isValidLongitude(lng) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(lng) && lng >= -180.0 && lng <= 180.0;
    },
    isValidLatitude: function isValidLatitude(lat) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(lat) && lat >= -90.0 && lat <= 90.0;
    },
    tagEmailConverter: function tagEmailConverter(name) {
      if (name && name.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        this.emails.push(name);
        this.emailsOptions.push(name);
      }
    },
    close: function close() {
      this.$emit('close');
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.init();
    });
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Subscriptions',
  data: function data() {
    return {
      subscriptions: [],
      selectedSubscription: null,
      size: 10,
      page: 0,
      total: 0,
      pageTotal: 0,
      sortField: 'name',
      desc: 'true',
      query: null
    };
  },

  methods: {
    onPageSizeChange: function onPageSizeChange(event) {
      this.size = event.target.value;
      this.refresh(true);
    },
    onPageChange: function onPageChange(pageNum) {
      this.page = pageNum - 1;
      this.refresh();
    },
    sortBy: function sortBy(sortField, desc) {
      this.sortField = sortField;
      this.desc = desc;
      this.refresh(true);
    },
    refresh: function refresh() {
      var toFirstPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.search(toFirstPage);
    },
    search: function search() {
      var _this = this;

      var toFirstPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (toFirstPage) {
        this.page = 0;
      }

      var endpoint = '/notifications?size=' + this.size + '&page=' + this.page + '&sortField=' + this.sortField + '&desc=' + this.desc;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNil(this.query) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(this.query)) {
        endpoint += '&q=' + this.query;
      }

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('GET', endpoint).then(function (response) {
        _this.subscriptions = response.data;
        _this.total = response.data.length;
        _this.pageTotal = Math.ceil(_this.total / _this.size);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    showSubscriptionDialog: function showSubscriptionDialog(subscription) {
      this.selectedSubscription = subscription;
      window.jQuery('#new-subscription-modal').modal('show');
    },
    deleteSubscription: function deleteSubscription(subscriptionId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('DELETE', '/notifications/' + subscriptionId).then(function () {
        _this2.closeModal();
        _this2.refresh(true);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    },
    closeModal: function closeModal() {
      window.jQuery('#new-subscription-modal').modal('hide');
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      var that = _this3;
      _this3.refresh(true);

      window.jQuery('#new-subscription-modal').modal({ show: false }).on('show.bs.modal', function () {
        that.$refs['subscription-modal'].init(that.selectedSubscription);
      }).on('shown.bs.modal', function () {
        that.$refs['subscription-modal'].initMap();
      }).on('hidden.bs.modal', function () {
        that.refresh(true);
      });
    });
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagsSearch',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
  data: function data() {
    return {
      options: [],
      selected: []
    };
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].authenticatedRequest('get', '/tags').then(function (response) {
        _this.options = response.data.data;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    tagLabelFormatter: function tagLabelFormatter(option) {
      return option.name;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.refresh();
    });
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Testimonies',
  data: function data() {
    return {
      globalEnpoint: '/testimonies',
      searchEndpoint: '/testimonies/search',
      additionalQueryParam: '',
      searchEnabled: true
    };
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TestimoniesList',
  props: ['globalEnpoint', 'searchEndpoint', 'searchEnabled', 'additionalQueryParam'],
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a },
  data: function data() {
    return {
      testimonies: [],
      selectedTestimonies: [],
      tagsByTestimony: {},
      startCreationDate: null,
      endCreationDate: null,
      startAttackDate: null,
      endAttackDate: null,
      query: null,
      size: 10,
      pageTotal: 0,
      total: 0,
      page: 0,
      sortField: 'creationDate',
      desc: 'true'
    };
  },

  methods: {
    goTo: function goTo(testimony) {
      var id = testimony._id ? testimony._id : testimony.id;
      this.$router.push({ name: 'Testimony', params: { id: id } });
    },
    sortBy: function sortBy(sortField, desc) {
      this.sortField = sortField;
      this.desc = desc;
      this.refresh(true);
    },
    changePage: function changePage(pageNum) {
      this.page = pageNum - 1;
      this.refresh();
    },
    showSizeChange: function showSizeChange(e) {
      this.size = e.target.value;
      this.refresh(true);
    },
    refresh: function refresh() {
      var toFirstPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (toFirstPage) {
        this.page = 0;
      }

      this.getTagsGroupByTestimony();

      if (this.$route.query.tag) {
        this.searchByTag(this.$route.query.tag);
      } else if (!this.isSearch()) {
        this.getTestimonies();
      } else {
        this.search(false);
      }
    },
    searchChange: function searchChange(e) {
      this.refresh(true);
    },
    searchByTag: function searchByTag(tagName) {
      var _this = this;

      this.$refs['tags-search'].selected = [{ name: tagName }];
      var endpoint = this.searchEndpoint + '?q=*&size=' + this.size + '&page=0&sortField=' + this.sortField + '&desc=' + this.desc + this.additionalQueryParam + '&tag=' + tagName;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', endpoint).then(function (response) {
        var data = response.data;
        _this.testimonies = data.data;
        _this.total = data.total;
        _this.pageTotal = Math.ceil(_this.total / _this.size);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    },
    isSearch: function isSearch() {
      return this.query !== null && this.query !== '' || this.startCreationDate !== null && this.startCreationDate !== '' || this.endCreationDate !== null && this.endCreationDate !== '' || this.startAttackDate !== null && this.startAttackDate !== '' || this.endAttackDate !== null && this.endAttackDate !== '' || this.$refs['tags-search'].selected.size > 0;
    },
    search: function search() {
      var _this2 = this;

      var isNewSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isNewSearch) {
        this.page = 0;
      }
      var endpoint = this.searchEndpoint + '?q=' + (this.query === null || this.query === '' ? '*' : this.query) + '&size=' + this.size + '&page=' + this.page + '&sortField=' + this.sortField + '&desc=' + this.desc + this.additionalQueryParam;
      if (this.startCreationDate) {
        endpoint += '&startCreationDate=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.startCreationDate).format('MM/DD/YYYY');
      }
      if (this.endCreationDate) {
        endpoint += '&endCreationDate=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.endCreationDate).format('MM/DD/YYYY');
      }
      if (this.startAttackDate) {
        endpoint += '&startAttackDate=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.startAttackDate).format('MM/DD/YYYY');
      }
      if (this.endAttackDate) {
        endpoint += '&endAttackDate=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.endAttackDate).format('MM/DD/YYYY');
      }
      this.$refs['tags-search'].selected.forEach(function (tag) {
        endpoint += '&tag=' + tag.name;
      });
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', endpoint).then(function (response) {
        var data = response.data;
        _this2.testimonies = data.data;
        _this2.total = data.total;
        _this2.pageTotal = Math.ceil(_this2.total / _this2.size);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    },
    getTestimonies: function getTestimonies() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', this.globalEnpoint + '?size=' + this.size + '&page=' + this.page + '&sortField=' + this.sortField + '&desc=' + this.desc + this.additionalQueryParam).then(function (response) {
        var data = response.data;
        _this3.testimonies = data.data;
        _this3.total = data.total;
        _this3.pageTotal = Math.ceil(_this3.total / _this3.size);
        _this3.$emit('loaded', _this3.testimonies);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this3.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this3.response = 'Server appears to be offline';
      });
    },
    getTagsGroupByTestimony: function getTagsGroupByTestimony() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/tags?groupBy=testimonyId').then(function (response) {
        response.data.forEach(function (item) {
          _this4.tagsByTestimony[item.occurrenceId] = item.tags;
        });
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this4.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this4.response = 'Server appears to be offline';
      });
    },
    updateTestimoniesStatus: function updateTestimoniesStatus(status) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('patch', '/testimonies/_update-status', { ids: this.selectedTestimonies, status: status }).then(function () {
        if (_this5.isSearch()) {
          _this5.selectedTestimonies.forEach(function (testimonyId) {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + testimonyId + '?read=false').then(function (data) {
              var testimony = data.data;
              _this5.testimonies = _this5.testimonies.map(function (item) {
                return item._id === testimony._id ? testimony : item;
              });
            });
          });
        } else {
          _this5.refresh();
        }
        _this5.clearSelection();
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this5.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this5.response = 'Server appears to be offline';
      });
    },
    toggleSelection: function toggleSelection($event, testimony) {
      var $ = window.jQuery;
      var $target = $($event.target);
      var $toggle = $target.closest('td').find('input:checkbox');

      if (!$target.is('input:checkbox')) {
        $toggle.prop('checked', !$toggle.is(':checked'));
      }

      var testimonyIndex = this.selectedTestimonies.indexOf(testimony._id);
      if ($toggle.is(':checked') && testimonyIndex === -1) {
        this.selectedTestimonies.push(testimony._id);
      } else if (!$toggle.is(':checked') && testimonyIndex > -1) {
        this.selectedTestimonies.splice(testimonyIndex, 1);
      }
    },
    clearSelection: function clearSelection() {
      this.selectedTestimonies = [];
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.refresh();
    });
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_async__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FilePreviewer_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FilePreviewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FilePreviewer_vue__);









var pluginURL = '/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.min.js';
var mapURL = '/static/js/plugins/jvectormap/jquery-jvectormap-world-mill.js';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Testimony',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a, FilePreviewer: __WEBPACK_IMPORTED_MODULE_6__FilePreviewer_vue___default.a },
  data: function data() {
    return {
      id: this.$route.params.id,
      file: null,
      similars: [],
      testimony: null,
      testimonyMarker: null,
      editMode: false,
      cases: [],
      uploadEndPoint: null,
      anchors: [],
      caseToDetach: null,
      markers: []
    };
  },

  methods: {
    refresh: function refresh(obj) {
      this.testimony = obj.response;
    },
    getStartTime: function getStartTime() {
      if (this.testimony && this.testimony.actionPeriod) {
        var hour = 12;
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.testimony.actionPeriod.startDate).hour(hour);
      }
    },
    getUrl: function getUrl(file) {
      return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].serverURI + '/testimonies/' + this.id + '/attachments/' + file + '?token=' + window.localStorage.getItem('token').substring(7);
    },
    getRecordingUrl: function getRecordingUrl(file) {
      return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].serverURI + '/testimonies/' + this.id + '/recordings/' + file + '?token=' + window.localStorage.getItem('token').substring(7);
    },
    getToken: function getToken() {
      return { 'Authorization': window.localStorage.getItem('token') };
    },
    getUploadEndpoint: function getUploadEndpoint() {
      return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].serverURI + '/testimonies/' + this.id + '/' + this.testimony.version + '/attachments';
    },
    confirm: function confirm() {
      window.jQuery('#ConfirmModal').modal({});
    },
    confirmDeleteFile: function confirmDeleteFile(file) {
      this.file = file;
      window.jQuery('#ConfirmDeleteFileModal').modal({});
    },
    confirmRemoveLink: function confirmRemoveLink(caseId) {
      this.caseToDetach = caseId;
      window.jQuery('#ConfirmLinkModal').modal({});
    },
    removeLink: function removeLink() {
      var _this = this;

      var body = {
        testimonyId: this.id,
        version: this.testimony.version
      };
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('delete', '/cases/' + this.caseToDetach + '/testimonies', body).then(function (response) {
        _this.getTestimony();
        _this.getRelatedCases();
      }).catch(function (error) {
        console.log(error);
      });
    },
    openLinkModal: function openLinkModal() {
      this.$refs.linkCaseModal.removeLinkedCases();
      window.jQuery('#LinkCaseModal').modal({});
    },
    linkAll: function linkAll(selectedCases) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_async___default.a.eachOfSeries(selectedCases, this.link, function (err) {
        if (err) console.log(err);
        _this2.getTestimony();
        _this2.getRelatedCases();
      });
    },
    link: function link(selectedCase, index, callback) {
      var body = {
        testimonyId: this.id,
        version: this.testimony.version + index
      };
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('post', '/cases/' + selectedCase._id + '/testimonies', body).then(function (response) {
        callback();
      }).catch(function (error) {
        console.log(error);
        callback(error);
      });
    },
    getSimilars: function getSimilars() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + this.id + '/similar').then(function (response) {
        _this3.similars = response.data.data;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this3.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this3.response = 'Server appears to be offline';
      });
    },
    getRelatedCases: function getRelatedCases() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + this.id + '/cases').then(function (response) {
        _this4.cases = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    goToCase: function goToCase(relatedCase) {
      var id = relatedCase._id ? relatedCase._id : relatedCase.id;
      this.$router.push({ name: 'Case', params: { id: id } });
    },
    deleteFile: function deleteFile() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('delete', '/testimonies/' + this.id + '/' + this.testimony.version + '/attachments/' + this.file).then(function (response) {
        _this5.testimony = response.data;
      }).catch(function (error) {
        console.log(error);
        _this5.goToReadMode();
        if (error.response.status === 401) {
          _this5.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this5.response = 'Server appears to be offline';
      });
    },
    archive: function archive() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('delete', '/testimonies/' + this.id + '?version=' + this.testimony.version).then(function (response) {
        _this6.$router.push({ name: 'Testimonies' });
      }).catch(function (error) {
        console.log(error);
        _this6.goToReadMode();
        if (error.response.status === 401) {
          _this6.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this6.response = 'Server appears to be offline';
      });
    },
    anchor: function anchor() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('post', '/testimonies/' + this.id + '/anchor/' + this.testimony.version).then(function (response) {
        _this7.testimony = response.data.testimony;
        _this7.getAnchors();
      }).catch(function (error) {
        console.log(error);
        _this7.goToReadMode();
        if (error.response.status === 401) {
          _this7.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this7.response = 'Server appears to be offline';
      });
    },
    goToEditMode: function goToEditMode() {
      this.editMode = true;
    },
    goToReadMode: function goToReadMode() {
      this.editMode = false;
    },
    save: function save() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('post', '/testimonies/' + this.id + '/comment', { comment: this.testimony.comment, version: this.testimony.version }).then(function (response) {
        _this8.editMode = false;
        _this8.testimony = response.data;
      }).catch(function (error) {
        console.log(error);
        _this8.goToReadMode();
        if (error.response.status === 401) {
          _this8.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this8.response = 'Server appears to be offline';
      });
    },
    getTestimony: function getTestimony() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + this.id).then(function (response) {
        _this9.testimony = response.data;

        var testimonyMarker = __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].extractTestimonyMarker(_this9.testimony);
        if (testimonyMarker) {
          _this9.testimonyMarker = testimonyMarker;
        }
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this9.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this9.response = 'Server appears to be offline';
      });
    },
    makeMap: function makeMap() {
      var _this10 = this;

      window.jQuery.getScript(pluginURL, function () {
        window.jQuery.getScript(mapURL, function () {
          window.jQuery('#world-map-markers').vectorMap({
            map: 'world_mill',
            regionStyle: {
              initial: {
                fill: 'white',
                'fill-opacity': 1,
                stroke: 'rgb(80,80,80)',
                'stroke-width': 0.5,
                'stroke-opacity': 0.5
              },
              hover: {
                'fill-opacity': 0.8,
                cursor: 'pointer'
              },
              selected: {
                fill: 'yellow'
              },
              selectedHover: {}
            },
            backgroundColor: '#747B83',
            zoomOnScroll: false,
            scaleColors: ['#C8EEFF', '#0071A4'],
            normalizeFunction: 'polynomial',
            markerStyle: {
              initial: {
                fill: '#E14253',
                stroke: '#b43442'
              },
              hover: {
                stroke: '#747B83',
                'stroke-width': 1,
                cursor: 'pointer',
                'fill-opacity': 0.8
              }
            },
            markerLabelStyle: {
              initial: {
                'font-family': 'Verdana',
                'font-size': '12',
                'font-weight': 'bold',
                cursor: 'default',
                fill: 'black'
              },
              hover: {
                cursor: 'pointer'
              }
            },
            markers: _this10.markers,
            onMarkerClick: _this10.onMarkerClick
          });
        });
      });
    },
    getMarkers: function getMarkers() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/testimonies?size=100&sortField=creationDate&desc=true').then(function (response) {
        var data = response.data;
        _this11.markers = data.data.filter(function (testimony) {
          return testimony && testimony.actionDetail && testimony.actionDetail.actionLocation && testimony.actionDetail.actionLocation.geoLocation && testimony.actionDetail.actionLocation.geoLocation.coordinates && testimony.actionDetail.actionLocation.geoLocation.coordinates.length === 2;
        }).map(function (testimony) {
          return {
            latLng: [testimony.actionDetail.actionLocation.geoLocation.coordinates[1], testimony.actionDetail.actionLocation.geoLocation.coordinates[0]],
            name: testimony.actionDetail.actionLocation.zone,
            id: testimony._id
          };
        });
        _this11.makeMap();
        _this11.total = data.total;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this11.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this11.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this12 = this;

    this.$nextTick(function () {
      _this12.getTestimony();
      _this12.getRelatedCases();
      _this12.getSimilars();
    });
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_async__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_async__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TestimonyHistory',
  data: function data() {
    return {
      id: this.$route.params.id,
      file: null,
      similars: [],
      testimony: null,
      editMode: false,
      cases: [],
      uploadEndPoint: null,
      anchors: [],
      caseToDetach: null
    };
  },

  methods: {
    refresh: function refresh(obj) {
      this.testimony = obj.response;
      this.$refs.timeline.getHistory();
    },
    getStartTime: function getStartTime() {
      if (this.testimony && this.testimony.actionPeriod) {
        var hour = 12;
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.testimony.actionPeriod.startDate).hour(hour);
      }
    },
    getUrl: function getUrl(file) {
      return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/testimonies/' + this.id + '/attachments/' + file + '?token=' + window.localStorage.getItem('token').substring(7);
    },
    getToken: function getToken() {
      return { 'Authorization': window.localStorage.getItem('token') };
    },
    getUploadEndpoint: function getUploadEndpoint() {
      return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/testimonies/' + this.id + '/' + this.testimony.version + '/attachments';
    },
    confirm: function confirm() {
      window.jQuery('#ConfirmModal').modal({});
    },
    confirmDeleteFile: function confirmDeleteFile(file) {
      this.file = file;
      window.jQuery('#ConfirmDeleteFileModal').modal({});
    },
    confirmRemoveLink: function confirmRemoveLink(caseId) {
      this.caseToDetach = caseId;
      window.jQuery('#ConfirmLinkModal').modal({});
    },
    removeLink: function removeLink() {
      var _this = this;

      var body = {
        testimonyId: this.id,
        version: this.testimony.version
      };
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('delete', '/cases/' + this.caseToDetach + '/testimonies', body).then(function (response) {
        _this.getTestimony();
        _this.$refs.timeline.getHistory();
        _this.getRelatedCases();
      }).catch(function (error) {
        console.log(error);
      });
    },
    openLinkModal: function openLinkModal() {
      this.$refs.linkCaseModal.removeLinkedCases();
      window.jQuery('#LinkCaseModal').modal({});
    },
    linkAll: function linkAll(selectedCases) {
      var _this2 = this;

      console.log('about to add selected Cases : ');
      console.log(selectedCases);
      __WEBPACK_IMPORTED_MODULE_3_async___default.a.eachOfSeries(selectedCases, this.link, function (err) {
        if (err) console.log(err);
        _this2.getTestimony();
        _this2.$refs.timeline.getHistory();
        _this2.getRelatedCases();
      });
    },
    link: function link(selectedCase, index, callback) {
      console.log(selectedCase);
      var body = {
        testimonyId: this.id,
        version: this.testimony.version + index
      };
      console.log(body);
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('post', '/cases/' + selectedCase._id + '/testimonies', body).then(function (response) {
        callback();
      }).catch(function (error) {
        console.log(error);
        callback(error);
      });
    },
    getSimilars: function getSimilars() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + this.id + '/similar').then(function (response) {
        _this3.similars = response.data.data;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this3.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this3.response = 'Server appears to be offline';
      });
    },
    getRelatedCases: function getRelatedCases() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + this.id + '/cases').then(function (response) {
        _this4.cases = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteFile: function deleteFile() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('delete', '/testimonies/' + this.id + '/' + this.testimony.version + '/attachments/' + this.file).then(function (response) {
        _this5.testimony = response.data;
        _this5.$refs.timeline.getHistory();
      }).catch(function (error) {
        console.log(error);
        _this5.goToReadMode();
        if (error.response.status === 401) {
          _this5.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this5.response = 'Server appears to be offline';
      });
    },
    archive: function archive() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('delete', '/testimonies/' + this.id + '?version=' + this.testimony.version).then(function (response) {
        _this6.$router.push({ name: 'Testimonies' });
      }).catch(function (error) {
        console.log(error);
        _this6.goToReadMode();
        if (error.response.status === 401) {
          _this6.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this6.response = 'Server appears to be offline';
      });
    },
    anchor: function anchor() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('post', '/testimonies/' + this.id + '/anchor/' + this.testimony.version).then(function (response) {
        _this7.testimony = response.data.testimony;
        _this7.getAnchors();
        _this7.$refs.timeline.getHistory();
      }).catch(function (error) {
        console.log(error);
        _this7.goToReadMode();
        if (error.response.status === 401) {
          _this7.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this7.response = 'Server appears to be offline';
      });
    },
    goToEditMode: function goToEditMode() {
      this.editMode = true;
    },
    goToReadMode: function goToReadMode() {
      this.editMode = false;
    },
    save: function save() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('post', '/testimonies/' + this.id + '/comment', { comment: this.testimony.comment, version: this.testimony.version }).then(function (response) {
        _this8.editMode = false;
        _this8.testimony = response.data;
        _this8.$refs.timeline.getHistory();
      }).catch(function (error) {
        console.log(error);
        _this8.goToReadMode();
        if (error.response.status === 401) {
          _this8.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this8.response = 'Server appears to be offline';
      });
    },
    getTestimony: function getTestimony() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + this.id).then(function (response) {
        _this9.testimony = response.data;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this9.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this9.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    this.$nextTick(function () {
      _this10.getTestimony();
      _this10.getRelatedCases();
      _this10.getSimilars();
    });
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_deep_diff__ = __webpack_require__(361);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Timeline',
  props: ['id', 'testimony'],
  data: function data() {
    return {
      history: []
    };
  },

  methods: {
    sameDate: function sameDate(firstDate, secondDate) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstDate).isSame(secondDate, 'day');
    },
    getDiff: function getDiff(firstDoc, secondDoc) {
      var differences = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_deep_diff__["a" /* default */])(firstDoc, secondDoc);
      if (differences) {
        var filteredDifferences = differences.filter(function (difference) {
          return !difference.path.some(function (path) {
            return path === 'updatedAt' || path === 'updatedBy' || path === 'version';
          });
        });
        return filteredDifferences;
      } else {
        return [];
      }
    },
    customizeDiff: function customizeDiff(firstDoc, secondDoc) {
      if (!firstDoc || !secondDoc) {
        return [];
      }
      var differences = this.getDiff(firstDoc, secondDoc);
      return differences.map(function (difference) {
        if (difference.path.indexOf('anchoredAt') !== -1) {
          return 'This <strong><i>testimony</i></strong> has been anchored and secured for later use\n';
        } else if (difference.path.indexOf('cases') !== -1) {
          if (difference.item && difference.item.kind === 'D') {
            return 'This testimony has been attached to a <strong><i>case</i></strong> : <strong><i>' + difference.item.lhs + '</strong></i>\n';
          } else if (difference.item && difference.item.kind === 'N') {
            return 'This testimony has been detached from a <strong><i>case</i></strong> : <strong><i>' + difference.item.rhs + '</strong></i>\n';
          } else if (difference.kind === 'N') {
            return 'This testimony has been detached from a <strong><i>case</i></strong> : <strong><i>' + difference.rhs + '</strong></i>\n';
          } else if (difference.kind === 'D') {
            return 'This testimony has been attached to a <strong><i>case</i></strong> : <strong><i>' + difference.lhs + '</strong></i>\n';
          } else {
            return '';
          }
        } else if (difference.path.indexOf('attachments') !== -1) {
          if (difference.item && difference.item.kind === 'D') {
            return 'An <strong><i>attachment</i></strong> has been added to this testimony : <strong><i>' + difference.item.lhs + '</strong></i>\n';
          } else if (difference.item && difference.item.kind === 'N') {
            return 'An <strong><i>attachment</i></strong> has been removed from this testimony : <strong><i>' + difference.item.rhs + '</strong></i>\n';
          } else if (difference.kind === 'N') {
            return 'An <strong><i>attachment</i></strong> has been deleted : <strong><i>' + difference.rhs + '</strong></i>\n';
          } else if (difference.kind === 'D') {
            return 'New <strong><i>attachment</i></strong> has been uploaded : <strong><i>' + difference.lhs + '</strong></i>\n';
          } else {
            return '';
          }
        } else {
          return 'Field <strong><i>' + difference.path + '</i></strong> has been updated :<br>' + (difference.rhs ? difference.rhs : '<i>No data</i>') + ' &nbsp;&nbsp;&nbsp;<i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;&nbsp;' + difference.lhs + '\n';
        }
      });
    },
    getHistory: function getHistory() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/testimonies/' + this.id + '/history').then(function (response) {
        _this.history = response.data.data.map(function (testimony) {
          return testimony.document;
        });
        _this.history.unshift(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.testimony)));
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.getHistory();
    });
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  methods: {
    openModal: function openModal() {
      window.jQuery('#NewUserModal').modal({});
    },
    createUser: function createUser(user) {
      var _this = this;

      console.log('create user : ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].authenticatedRequest('post', '/users', user).then(function (response) {
        _this.$refs.usersList.refresh(true);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UsersList',
  props: [],
  data: function data() {
    return {
      users: [],
      toDelete: null,
      size: 10,
      pageTotal: 0,
      total: 0,
      page: 0,
      sortField: 'creationDate',
      desc: 'true'
    };
  },

  methods: {
    remove: function remove() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('delete', '/users/' + this.toDelete).then(function (response) {
        _this.toDelete = null;
        _this.refresh();
      }).catch(function (error) {
        console.log(error);
      });
    },
    confirmRemoveUser: function confirmRemoveUser(toDelete) {
      this.toDelete = toDelete;
      window.jQuery('#ConfirmModal').modal({});
    },
    openModal: function openModal() {
      this.$emit('openModal');
    },
    sortBy: function sortBy(sortField, desc) {
      this.sortField = sortField;
      this.desc = desc;
      this.refresh(true);
    },
    changePage: function changePage(pageNum) {
      this.page = pageNum - 1;
      this.refresh();
    },
    showSizeChange: function showSizeChange(e) {
      this.size = e.target.value;
      this.refresh(true);
    },
    refresh: function refresh() {
      var toFirstPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (toFirstPage) {
        this.page = 0;
      }
      this.getUsers();
    },
    getUsers: function getUsers() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].authenticatedRequest('get', '/users?size=' + this.size + '&page=' + this.page + '&sortField=' + this.sortField + '&desc=' + this.desc).then(function (response) {
        var data = response.data;
        _this2.users = data.data;
        _this2.total = data.total;

        _this2.pageTotal = parseInt(_this2.total / _this2.size) + 1;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.refresh();
    });
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__weather__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['longitude', 'latitude', 'testimonyTime'],
  data: function data() {
    return {
      woeid: '1947122',
      location: '',
      summary: '',
      status: '',
      time: '',
      temperature: '0',
      humidity: '0',
      wind: '0',
      pressure: '0',
      forecast: [],
      error: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.changeLocation();
    });
  },

  methods: {
    changeLocation: function changeLocation() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__weather__["a" /* default */].get(this.latitude, this.longitude, __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.testimonyTime).format('X')).then(function (response) {
        var data = response.data.currently;
        if (data) {
          _this2.time = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(data.time);
          _this2.status = data.icon;
          _this2.temperature = Math.round((data.temperature - 32) * (5 / 9) * 10) / 10;
          _this2.humidity = data.humidity;
          _this2.pressure = data.pressure;
          _this2.wind = Math.round(data.windSpeed * 1.609344 * 10) / 10;
          _this2.summary = data.summary;
          _this2.error = false;
        }
      }).catch(function (error) {
        console.log(error);
        if (error) {
          self.error = true;
        }
      });
    },
    getThumbnail: function getThumbnail(status, size) {
      var cdn = 'https://ssl.gstatic.com/onebox/weather';
      switch (status.toLowerCase()) {
        case 'hot':
          return cdn + '/' + size + '/hot.png';
        case 'clear-day':
        case 'clear-night':
          return cdn + '/' + size + '/sunny.png';
        case 'thunderstorms':
        case 'severe thunderstorms':
          return cdn + '/' + size + '/thunderstorms.png';
        case 'scattered thunderstorms':
          return cdn + '/' + size + '/rain_s_cloudy.png';
        case 'partly-cloudy-day':
        case 'mostly cloudy':
          return cdn + '/' + size + '/partly_cloudy.png';
        case 'cloudy':
        case 'fog':
          return cdn + '/' + size + '/cloudy.png';
        case 'showers':
        case 'scattered showers':
          return cdn + '/' + size + '/rain_light.png';
        case 'rain':
          return cdn + '/' + size + '/rain.png';
        case 'snow':
        case 'heavy snow':
        case 'snow flurries':
        case 'blowing snow':
          return cdn + '/' + size + '/snow.png';
        case 'sleet':
          return cdn + '/' + size + '/sleet.png';
        case 'wind':
          return cdn + '/' + size + '/windy.png';
        default:
          return cdn + '/' + size + '/cloudy.png';
      }
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(19);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: [''],
  data: function data() {
    return {
      markers: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.loadTestimonies();
    });
  },

  methods: {
    loadTestimonies: function loadTestimonies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].authenticatedRequest('get', '/testimonies/all').then(function (response) {
        var data = response.data;
        var testimonies = data.data;

        _this2.markers = __WEBPACK_IMPORTED_MODULE_1__helper__["a" /* default */].extractTestimoniesMarkers(testimonies, true);
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _this2.response = 'Username/Password incorrect. Please try again.';
          return;
        }
        _this2.response = 'Server appears to be offline';
      });
    }
  }
});

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 52,
	"./af.js": 52,
	"./ar": 59,
	"./ar-dz": 53,
	"./ar-dz.js": 53,
	"./ar-kw": 54,
	"./ar-kw.js": 54,
	"./ar-ly": 55,
	"./ar-ly.js": 55,
	"./ar-ma": 56,
	"./ar-ma.js": 56,
	"./ar-sa": 57,
	"./ar-sa.js": 57,
	"./ar-tn": 58,
	"./ar-tn.js": 58,
	"./ar.js": 59,
	"./az": 60,
	"./az.js": 60,
	"./be": 61,
	"./be.js": 61,
	"./bg": 62,
	"./bg.js": 62,
	"./bm": 63,
	"./bm.js": 63,
	"./bn": 65,
	"./bn-bd": 64,
	"./bn-bd.js": 64,
	"./bn.js": 65,
	"./bo": 66,
	"./bo.js": 66,
	"./br": 67,
	"./br.js": 67,
	"./bs": 68,
	"./bs.js": 68,
	"./ca": 69,
	"./ca.js": 69,
	"./cs": 70,
	"./cs.js": 70,
	"./cv": 71,
	"./cv.js": 71,
	"./cy": 72,
	"./cy.js": 72,
	"./da": 73,
	"./da.js": 73,
	"./de": 76,
	"./de-at": 74,
	"./de-at.js": 74,
	"./de-ch": 75,
	"./de-ch.js": 75,
	"./de.js": 76,
	"./dv": 77,
	"./dv.js": 77,
	"./el": 78,
	"./el.js": 78,
	"./en-au": 79,
	"./en-au.js": 79,
	"./en-ca": 80,
	"./en-ca.js": 80,
	"./en-gb": 81,
	"./en-gb.js": 81,
	"./en-ie": 82,
	"./en-ie.js": 82,
	"./en-il": 83,
	"./en-il.js": 83,
	"./en-in": 84,
	"./en-in.js": 84,
	"./en-nz": 85,
	"./en-nz.js": 85,
	"./en-sg": 86,
	"./en-sg.js": 86,
	"./eo": 87,
	"./eo.js": 87,
	"./es": 91,
	"./es-do": 88,
	"./es-do.js": 88,
	"./es-mx": 89,
	"./es-mx.js": 89,
	"./es-us": 90,
	"./es-us.js": 90,
	"./es.js": 91,
	"./et": 92,
	"./et.js": 92,
	"./eu": 93,
	"./eu.js": 93,
	"./fa": 94,
	"./fa.js": 94,
	"./fi": 95,
	"./fi.js": 95,
	"./fil": 96,
	"./fil.js": 96,
	"./fo": 97,
	"./fo.js": 97,
	"./fr": 100,
	"./fr-ca": 98,
	"./fr-ca.js": 98,
	"./fr-ch": 99,
	"./fr-ch.js": 99,
	"./fr.js": 100,
	"./fy": 101,
	"./fy.js": 101,
	"./ga": 102,
	"./ga.js": 102,
	"./gd": 103,
	"./gd.js": 103,
	"./gl": 104,
	"./gl.js": 104,
	"./gom-deva": 105,
	"./gom-deva.js": 105,
	"./gom-latn": 106,
	"./gom-latn.js": 106,
	"./gu": 107,
	"./gu.js": 107,
	"./he": 108,
	"./he.js": 108,
	"./hi": 109,
	"./hi.js": 109,
	"./hr": 110,
	"./hr.js": 110,
	"./hu": 111,
	"./hu.js": 111,
	"./hy-am": 112,
	"./hy-am.js": 112,
	"./id": 113,
	"./id.js": 113,
	"./is": 114,
	"./is.js": 114,
	"./it": 116,
	"./it-ch": 115,
	"./it-ch.js": 115,
	"./it.js": 116,
	"./ja": 117,
	"./ja.js": 117,
	"./jv": 118,
	"./jv.js": 118,
	"./ka": 119,
	"./ka.js": 119,
	"./kk": 120,
	"./kk.js": 120,
	"./km": 121,
	"./km.js": 121,
	"./kn": 122,
	"./kn.js": 122,
	"./ko": 123,
	"./ko.js": 123,
	"./ku": 124,
	"./ku.js": 124,
	"./ky": 125,
	"./ky.js": 125,
	"./lb": 126,
	"./lb.js": 126,
	"./lo": 127,
	"./lo.js": 127,
	"./lt": 128,
	"./lt.js": 128,
	"./lv": 129,
	"./lv.js": 129,
	"./me": 130,
	"./me.js": 130,
	"./mi": 131,
	"./mi.js": 131,
	"./mk": 132,
	"./mk.js": 132,
	"./ml": 133,
	"./ml.js": 133,
	"./mn": 134,
	"./mn.js": 134,
	"./mr": 135,
	"./mr.js": 135,
	"./ms": 137,
	"./ms-my": 136,
	"./ms-my.js": 136,
	"./ms.js": 137,
	"./mt": 138,
	"./mt.js": 138,
	"./my": 139,
	"./my.js": 139,
	"./nb": 140,
	"./nb.js": 140,
	"./ne": 141,
	"./ne.js": 141,
	"./nl": 143,
	"./nl-be": 142,
	"./nl-be.js": 142,
	"./nl.js": 143,
	"./nn": 144,
	"./nn.js": 144,
	"./oc-lnc": 145,
	"./oc-lnc.js": 145,
	"./pa-in": 146,
	"./pa-in.js": 146,
	"./pl": 147,
	"./pl.js": 147,
	"./pt": 149,
	"./pt-br": 148,
	"./pt-br.js": 148,
	"./pt.js": 149,
	"./ro": 150,
	"./ro.js": 150,
	"./ru": 151,
	"./ru.js": 151,
	"./sd": 152,
	"./sd.js": 152,
	"./se": 153,
	"./se.js": 153,
	"./si": 154,
	"./si.js": 154,
	"./sk": 155,
	"./sk.js": 155,
	"./sl": 156,
	"./sl.js": 156,
	"./sq": 157,
	"./sq.js": 157,
	"./sr": 159,
	"./sr-cyrl": 158,
	"./sr-cyrl.js": 158,
	"./sr.js": 159,
	"./ss": 160,
	"./ss.js": 160,
	"./sv": 161,
	"./sv.js": 161,
	"./sw": 162,
	"./sw.js": 162,
	"./ta": 163,
	"./ta.js": 163,
	"./te": 164,
	"./te.js": 164,
	"./tet": 165,
	"./tet.js": 165,
	"./tg": 166,
	"./tg.js": 166,
	"./th": 167,
	"./th.js": 167,
	"./tk": 168,
	"./tk.js": 168,
	"./tl-ph": 169,
	"./tl-ph.js": 169,
	"./tlh": 170,
	"./tlh.js": 170,
	"./tr": 171,
	"./tr.js": 171,
	"./tzl": 172,
	"./tzl.js": 172,
	"./tzm": 174,
	"./tzm-latn": 173,
	"./tzm-latn.js": 173,
	"./tzm.js": 174,
	"./ug-cn": 175,
	"./ug-cn.js": 175,
	"./uk": 176,
	"./uk.js": 176,
	"./ur": 177,
	"./ur.js": 177,
	"./uz": 179,
	"./uz-latn": 178,
	"./uz-latn.js": 178,
	"./uz.js": 179,
	"./vi": 180,
	"./vi.js": 180,
	"./x-pseudo": 181,
	"./x-pseudo.js": 181,
	"./yo": 182,
	"./yo.js": 182,
	"./zh-cn": 183,
	"./zh-cn.js": 183,
	"./zh-hk": 184,
	"./zh-hk.js": 184,
	"./zh-mo": 185,
	"./zh-mo.js": 185,
	"./zh-tw": 186,
	"./zh-tw.js": 186
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 406;

/***/ }),
/* 407 */,
/* 408 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  "data-v-011cde4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-previewer"
  }, [(_vm.isDisplaying) ? _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isDisplaying = false
      }
    }
  }, [_vm._v("Hide content")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.images.find(function (extension) { return _vm.name.endsWith(extension); })) ? _c('img', {
    attrs: {
      "src": _vm.source,
      "alt": _vm.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videos.find(function (extension) { return _vm.name.endsWith(extension); })) ? _c('video', {
    attrs: {
      "controls": "",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.getStream(),
      "type": "video/mp4"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.audios.find(function (extension) { return _vm.name.endsWith(extension); })) ? _c('audio', {
    attrs: {
      "controls": "",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.getStream(),
      "type": "audio/mpeg"
    }
  })]) : _vm._e()]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isDisplaying = true
      }
    }
  }, [_vm._v("Show content")])])
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.testimony) ? _c('timeline', {
    ref: "timeline",
    attrs: {
      "id": _vm.testimony._id,
      "testimony": _vm.testimony
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.link.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body col-lg-6"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cases,
      "multiple": true,
      "track-by": "_id",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.link
    }
  }, [_vm._v("Confirm")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Link this testimony to the following case(s) : ")])])
}]}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4",
    attrs: {
      "id": "example1_length"
    }
  }, [_c('label', [_vm._v("Show\n            "), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "name": "example1_length",
      "aria-controls": "example1"
    },
    on: {
      "change": _vm.showSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n          ")])]), _vm._v(" "), (_vm.selectedTestimonies && _vm.selectedTestimonies.length) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n            Mark " + _vm._s(_vm.selectedTestimonies.length) + " selected as  "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('READ')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope-open"
  }), _vm._v("Read")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('UNREAD')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _vm._v("Unread")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('PROCESSING')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale"
  }), _vm._v("Processing\n                ...")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('PROCESSED')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  }), _vm._v("Processed")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clearSelection()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ban"
  }), _vm._v("Clear selection")])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default col-sm-offset-1 col-sm-2 filter-btn",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#filters",
      "aria-expanded": "false",
      "aria-controls": "collapseExample"
    }
  }, [_vm._v("\n          Filters\n        ")])])]), _vm._v(" "), (_vm.searchEnabled) ? _c('div', {
    staticClass: "col-sm-6 search-table"
  }, [_c('div', {
    staticClass: "dataTables_filter",
    attrs: {
      "id": "example1_filter"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "placeholder": "Syria",
      "aria-controls": "example1"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "change": _vm.searchChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat btn-primary search-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row filters-row"
  }, [_c('div', {
    staticClass: "col-sm-12 collapse filters",
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "card card-body"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', [_vm._v("Get only testimonies created after")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.startCreationDate),
      callback: function($$v) {
        _vm.startCreationDate = $$v
      },
      expression: "startCreationDate"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("and before")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.endCreationDate),
      callback: function($$v) {
        _vm.endCreationDate = $$v
      },
      expression: "endCreationDate"
    }
  })], 1)]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('label', [_vm._v("And attack occured after")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.startAttackDate),
      callback: function($$v) {
        _vm.startAttackDate = $$v
      },
      expression: "startAttackDate"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("and before")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.endAttackDate),
      callback: function($$v) {
        _vm.endAttackDate = $$v
      },
      expression: "endAttackDate"
    }
  })], 1)]), _vm._v(" "), _c('tags-search', {
    ref: "tags-search"
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "aria-label": "Creation date",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Creation Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Purpose",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Lastname",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Victim name")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Minor",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Minor")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Gender",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'actionPeriod.startDate'
    },
    attrs: {
      "aria-label": "Attack date",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actionPeriod.startDate', 'true')
      }
    }
  }, [_vm._v("Attack date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Attack time",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Attack time\n            ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Place",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Place")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Origin",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Origin")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'similarNumbers'
    },
    attrs: {
      "aria-label": "Similar case",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('similarNumbers', 'true')
      }
    }
  }, [_vm._v("Similar")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Tags",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Tags",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Code")])])]), _vm._v(" "), (_vm.testimonies.length === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.testimonies), function(testimony) {
    return _c('tr', {
      class: testimony.status === 'UNREAD' ? 'unread' : '',
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(testimony)
        }
      }
    }, [_c('td', {
      staticClass: "text-center",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleSelection($event, testimony)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.selectedTestimonies.indexOf(testimony._id) !== -1
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(testimony.status === 'UNREAD') ? _c('i', {
      staticClass: "fa fa-envelope",
      attrs: {
        "title": "Unread"
      }
    }) : (testimony.status === 'PROCESSING') ? _c('i', {
      staticClass: "fa fa-balance-scale",
      attrs: {
        "title": "Processing ..."
      }
    }) : (testimony.status === 'PROCESSED') ? _c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "title": "Processed"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(testimony.creationDate)))]), _vm._v(" "), _c('td', [(testimony.purpose) ? _c('span', [_vm._v(_vm._s(testimony.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.victimIdentity) ? _c('span', [_vm._v(_vm._s(testimony.victimIdentity.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(testimony.victimIdentity && testimony.victimIdentity.minor ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [(testimony.victimIdentity) ? _c('span', [_vm._v(_vm._s(testimony.victimIdentity.gender))]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.actionPeriod) ? _c('span', [_vm._v("\n                " + _vm._s(_vm._f("prettyDate")(testimony.actionPeriod.startDate)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.actionPeriod) ? _c('span', [_vm._v("\n                " + _vm._s(_vm._f("prettyTime")(testimony.actionPeriod.startTime)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.actionDetail && testimony.actionDetail.actionLocation) ? _c('span', [_vm._v("\n                " + _vm._s(testimony.actionDetail.actionLocation.zone) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(testimony.originInfo ? testimony.originInfo.origin : 'UNKNOWN') + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(testimony.similarNumbers))]), _vm._v(" "), _c('td', _vm._l((_vm.tagsByTestimony[testimony._id]), function(tag) {
      return _c('span', {
        staticClass: "label label-default",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.searchByTag(tag)
          }
        }
      }, [_vm._v(_vm._s(tag))])
    }), 0), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(testimony.randomId) + "\n            ")])])
  }), 0)])])]), _vm._v(" "), (_vm.testimonies.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "example1_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("Showing\n        " + _vm._s(_vm.total - _vm.testimonies.length + 1 > _vm.page * _vm.size + 1 ? _vm.page * _vm.size + 1 : _vm.total - _vm.testimonies.length + 1) + "\n        to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline form-multiselect"
  }, [_c('label', [_vm._v("Tagged with")]), _vm._v(" "), _c('div', {
    staticClass: "multiselect-control"
  }, [_c('multiselect', {
    attrs: {
      "track-by": "name",
      "options": _vm.options,
      "multiple": true,
      "custom-label": _vm.tagLabelFormatter,
      "showLabels": false,
      "closeOnSelect": false,
      "disabled": !_vm.options.length,
      "placeholder": _vm.options.length ? 'Choose tag' : 'No tags available'
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.testimony) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Original Testimony : " + _vm._s(_vm.testimony.purpose ? _vm.testimony.purpose : '-'))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Delete"
    },
    on: {
      "click": _vm.confirm
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony.victimIdentity) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Victim Identity")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block victimIdentity"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.name ? _vm.testimony.victimIdentity.name : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.gender ? _vm.testimony.victimIdentity.gender : '-'))])])]), _vm._v(" "), (_vm.testimony.purpose === 'VICTIM') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Current location")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimLocation && _vm.testimony.victimLocation.otherPlace) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimLocation.otherPlace))]) : (_vm.testimony.victimLocation && _vm.testimony.victimLocation.place) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimLocation.place))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.victimLocation && _vm.testimony.victimLocation.countryName) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Country name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.victimLocation.countryName))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.purpose === 'VICTIM') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Surrounding")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimSurrounding && _vm.testimony.victimSurrounding.people) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimSurrounding.people.join(', ')))]) : (_vm.testimony.victimSurrounding && _vm.testimony.victimSurrounding.otherPeople) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimSurrounding.otherPeople))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.distressLevel) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Distress level")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.distressLevel && _vm.testimony.distressLevel.levels) ? _c('span', [_vm._v(_vm._s(_vm.testimony.distressLevel.levels.join(', ')))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.distressLevel && _vm.testimony.distressLevel.levels && _vm.testimony.distressLevel.levels.includes('ALREADY_ASSISTED')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Assistance description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(!_vm.testimony.distressLevel.alreadyAssistedDescription) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.distressLevel.alreadyAssistedDescription))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.distressLevel) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Psychological state description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.distressLevel.psychologicalStateDescription) ? _c('span', [_vm._v(_vm._s(_vm.testimony.distressLevel.psychologicalStateDescription))]) : _c('span', [_vm._v("-")])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Minor ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.minor ? 'Yes' : _vm.testimony.victimIdentity.minor === false ? 'No' : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._f("age")(_vm.testimony.victimIdentity.birthdate)))]) : _vm._e(), _vm._v(" "), (!_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("-")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Birth date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(new Date(_vm.testimony.victimIdentity.birthdate)))]) : _vm._e(), _vm._v(" "), (!_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("-")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Nationality")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.nationality ? _vm.testimony.victimIdentity.nationality : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Ethnic group")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.ethnicGroup ? _vm.testimony.victimIdentity.ethnicGroup : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Religion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.religion ? _vm.testimony.victimIdentity.religion : '-'))])])])]) : _vm._e()])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimIdentity.phoneNumber) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.phoneNumber))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimIdentity.email) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.email))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), (_vm.testimony.victimIdentity.organization) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.organization))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.victimIdentity.publicService) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Public service")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.publicService))])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimIdentity.contactDescription) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.contactDescription))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.witnessIdentity) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.witnessIdentity) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Witness")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.witnessIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.name ? _vm.testimony.witnessIdentity.name :
    '-'))])])]), _vm._v(" "), (_vm.testimony.purpose === 'THIRDPARTY_WITNESS') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.role ? _vm.testimony.witnessIdentity.role : '-'))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Status / profession")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.status ? _vm.testimony.witnessIdentity.status : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.witnessIdentity.phoneNumber) ? _c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.phoneNumber))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.witnessIdentity.email) ? _c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.email))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), (_vm.testimony.witnessIdentity.organization) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.organization))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.witnessIdentity.publicService) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Public service")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.publicService))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.witnessIdentity.contactDescription) ? _c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.contactDescription))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.witnessIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Nationality")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.nationality ? _vm.testimony.witnessIdentity.nationality : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Ethnic group")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.ethnicGroup ? _vm.testimony.witnessIdentity.ethnicGroup : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Religion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.religion ? _vm.testimony.witnessIdentity.religion : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Close to victim?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(typeof _vm.testimony.witnessIdentity.victimLocationProximity === 'undefined' ?
    '-' :
    _vm.testimony.witnessIdentity.victimLocationProximity ? 'Yes' : 'No'))])])])]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.actionDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.actionDetail) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Attack Details")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.actionDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack types")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.attackTypes ? _vm.testimony.actionDetail.attackTypes.join(', ') : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.attackDescription ? _vm.testimony.actionDetail.attackDescription : '-'))])])]), _vm._v(" "), (_vm.testimony.actionPeriodicity) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack periodicity")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionPeriodicity.periodicity) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionPeriodicity.periodicity.join(', ')))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionPeriodicity) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack periodicity details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionPeriodicity.description) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionPeriodicity.description))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionDetail.actionLocation.country) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.country))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Town")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionDetail.actionLocation.town) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.town))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), (_vm.testimony.actionDetail.actionLocation.prison) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Prison")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.prison))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionDetail.actionLocation.camp) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Camp")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.camp))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionDetail.actionLocation.ownPlace) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Home")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.ownPlace))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Road")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionDetail.actionLocation.road) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.road))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.actionDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("How many aggressors?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorNumber ? (_vm.testimony.actionDetail.aggressorNumber |
    _vm.prettyNumber) : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor Uniform")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorUniform ? _vm.testimony.actionDetail.aggressorUniform : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor distinctive sign")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorSign ? _vm.testimony.actionDetail.aggressorSign : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor nationality/ethnic group/religion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorAffiliations ? _vm.testimony.actionDetail.aggressorAffiliations : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor names")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorNames ? _vm.testimony.actionDetail.aggressorNames : '-'))])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.testimony.victimCondition) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Already assisted?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(typeof _vm.testimony.victimCondition.alreadyHelped === 'undefined' ? '-' :
    _vm.testimony.victimCondition.alreadyHelped ? 'Yes' : 'No'))])])]), _vm._v(" "), (_vm.testimony.victimCondition.helpDescription) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Help description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimCondition.helpDescription))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Need assistance?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(typeof _vm.testimony.victimCondition.helpNeeded === 'undefined' ? '-' :
    _vm.testimony.victimCondition.helpNeeded ? 'Yes' : 'No'))])])]), _vm._v(" "), (_vm.testimony.victimCondition.helpNeededDescription) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Assistance description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimCondition.helpNeededDescription))])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Threat Details")]) : _vm._e(), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.threatDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Heard rumor ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.threatDetail.rumor ? 'Yes' : _vm.testimony.threatDetail.rumor === false ? 'No' : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Bein afraid ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.threatDetail.fear ? 'Yes' : _vm.testimony.threatDetail.fear === false ? 'No' : '-'))])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.actionPeriod && _vm.testimony.actionPeriod.startDate) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Period")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.actionPeriod && _vm.testimony.actionPeriod.startDate) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.testimony.actionPeriod.startDate !== _vm.testimony.actionPeriod.endDate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n                        From " + _vm._s(_vm._f("prettyDate")(_vm.testimony.actionPeriod.startDate)) + " to " + _vm._s(_vm._f("prettyDate")(_vm.testimony.actionPeriod.endDate)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionPeriod.startDate === _vm.testimony.actionPeriod.endDate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("prettyDate")(_vm.testimony.actionPeriod.startDate)) + "\n                      ")]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.actionPeriod) ? _c('form', {
    staticClass: "form-horizontal"
  }, [(_vm.testimony.actionPeriod.startDate !== _vm.testimony.actionPeriod.endDate) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Approximate ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionPeriod.exactDate ? 'No' : 'Yes'))])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.crimeDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.crimeDetail) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Crime Details")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.crimeDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Any victim?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(typeof _vm.testimony.crimeDetail.anyVictim === 'undefined') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.anyVictim ? 'Yes' : 'No'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Where")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.where) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.where))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("When")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.when) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.when))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("How")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.how) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.how))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.crimeDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Number of victim")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.victimNumber) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.victimNumber))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Profiles of victim")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.victimProfiles) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.victimProfiles.join(', ')))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Is witness safe?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(typeof _vm.testimony.crimeDetail.witnessState.isSafe === 'undefined') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.witnessState.isSafe ? 'Yes' : 'No'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Was threatened?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(typeof _vm.testimony.crimeDetail.witnessState.hasBeenThreatened === 'undefined') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.witnessState.hasBeenThreatened ? 'Yes' : 'No'))])])])])]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.actionDetail && _vm.testimony.actionDetail.details) ? _c('span', [_c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("More details")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.details))])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Additional data")]), _vm._v(" "), (_vm.testimony && !_vm.editMode) ? _c('i', {
    staticClass: "fa fa-edit clickable pull-right",
    on: {
      "click": _vm.goToEditMode
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony && !_vm.editMode) ? _c('p', [_vm._v(_vm._s(_vm.testimony.comment))]) : _vm._e(), _vm._v(" "), (_vm.testimony && _vm.editMode) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimony.comment),
      expression: "testimony.comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.testimony.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testimony, "comment", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.testimony && _vm.editMode) ? _c('div', {
    staticClass: "box-footer add-data-testimony"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goToReadMode
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.testimony) ? _c('div', [_c('uploader', {
    attrs: {
      "headers": _vm.getToken(),
      "multiple": false,
      "end-point": _vm.getUploadEndpoint()
    },
    on: {
      "fileUploaded": _vm.refresh
    }
  }, [_c('button', {
    attrs: {
      "slot": "browse"
    },
    slot: "browse"
  }, [_vm._v("Add attachments")])]), _vm._v(" "), (_vm.testimony.attachments && _vm.testimony.attachments.length > 0) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.testimony.attachments), function(file) {
    return _c('li', {
      key: file,
      staticClass: "list-group-item list-group-item-action"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }), _vm._v(" "), _c('a', {
      staticClass: "file-name",
      attrs: {
        "href": _vm.getUrl(file)
      }
    }, [_vm._v(_vm._s(file))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash clickable pull-right",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeleteFile(file)
        }
      }
    }), _vm._v(" "), _c('file-previewer', {
      attrs: {
        "id": _vm.id,
        "name": file,
        "source": _vm.getUrl(file)
      }
    })], 1)
  }), 0) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony.recordings && _vm.testimony.recordings.length > 0) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.testimony.recordings), function(recording) {
    return _c('li', {
      key: recording,
      staticClass: "list-group-item list-group-item-action"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }), _vm._v(" "), _c('a', {
      staticClass: "file-name",
      attrs: {
        "href": _vm.getRecordingUrl(recording)
      }
    }, [_vm._v(_vm._s(recording))]), _vm._v(" "), _c('audio', {
      attrs: {
        "controls": "",
        "controlsList": "nodownload"
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.getRecordingUrl(recording),
        "type": "audio/webm"
      }
    })])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony) ? _c('osm-map', {
    attrs: {
      "markers": [_vm.testimonyMarker]
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony) ? _c('injuries', {
    attrs: {
      "victimCondition": _vm.testimony.victimCondition
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.testimony) ? _c('signaletics', {
    attrs: {
      "id": _vm.id,
      "status": _vm.testimony.status,
      "type": "testimonies"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Related Cases")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-link clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Link"
    },
    on: {
      "click": _vm.openLinkModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    class: {
      'no-padding': _vm.cases.length > 0
    }
  }, [(_vm.cases.length == 0) ? _c('p', [_vm._v("No related case")]) : _vm._e(), _vm._v(" "), (_vm.cases.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table relative-case-table table-bordered table-striped no-margin",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.cases), function(relatedCase) {
    return _c('tr', {
      staticClass: "even clickable",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.goToCase(relatedCase)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(relatedCase.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("prettyDateTime")(relatedCase.creationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(relatedCase.status))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-close clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Detach Case"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.confirmRemoveLink(relatedCase._id)
        }
      }
    })])])
  }), 0)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.testimony && _vm.testimony.version) ? _c('anchors', {
    attrs: {
      "id": _vm.id,
      "type": "testimonies",
      "anchorDone": "refresh",
      "version": _vm.testimony.version
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('label', [_vm._v("Type : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo ? _vm.testimony.originInfo.origin : "UNKNOWN"))]), _vm._v(" "), (_vm.testimony.originInfo && _vm.testimony.originInfo.version) ? _c('p', [_c('label', [_vm._v("Form version : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo.version))]) : _vm._e(), _vm._v(" "), (_vm.testimony.originInfo && _vm.testimony.originInfo.originId) ? _c('p', [_c('label', [_vm._v("Platform ID : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo.originId))]) : _vm._e(), _vm._v(" "), (_vm.testimony.originInfo && _vm.testimony.originInfo.originalCode) ? _c('p', [_c('label', [_vm._v("Original Code : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo.originalCode) + " ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('label', [_vm._v("Web Code : ")]), _vm._v(" " + _vm._s(_vm.testimony.randomId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    class: {
      'no-padding': _vm.similars.length > 0
    }
  }, [(!_vm.similars || _vm.similars.length == 0) ? _c('p', [_vm._v("No similar testimony")]) : _vm._e(), _vm._v(" "), (_vm.similars && _vm.similars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped no-margin",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.similars), function(similar) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [(similar && similar.actionDetail && similar.actionDetail.actionLocation) ? _c('span', [_vm._v("\n                          " + _vm._s(similar.actionDetail.actionLocation.zone) + "\n                          ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(similar.creationDate)))]), _vm._v(" "), _c('td', [(similar.victimIdentity) ? _c('span', [_vm._v("\n                            " + _vm._s(similar.victimIdentity.firstName) + " " + _vm._s(similar.victimIdentity.name) + "\n                          ")]) : _vm._e()])])
  }), 0)])])]) : _vm._e()])])]), _vm._v(" "), (_vm.testimony && _vm.testimony.actionPeriod && _vm.testimony.actionPeriod.startDate && _vm.testimonyMarker) ? _c('div', {
    staticClass: "row"
  }, [_c('automatic-data', {
    attrs: {
      "testimonyLocation": _vm.testimonyMarker.coordinates,
      "testimonyTime": _vm.getStartTime()
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to archive this testimony ?",
      "title": "Archive Confirmation",
      "id": "ConfirmModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.archive()
      }
    }
  }), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to detach this testimony to that case ?",
      "title": "Detach Confirmation",
      "id": "ConfirmLinkModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.removeLink()
      }
    }
  }), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to delete this attachment ?",
      "title": "Delete Confirmation",
      "id": "ConfirmDeleteFileModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.deleteFile()
      }
    }
  }), _vm._v(" "), _c('link-case-modal', {
    ref: "linkCaseModal",
    attrs: {
      "id": "LinkCaseModal",
      "preselected": _vm.cases
    },
    on: {
      "link": _vm.linkAll
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [_c('div', {
    staticClass: "form-horizontal form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Recordings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Location where testimony was saved")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Body injuries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Name\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Creation Date\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Status\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Origin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Similar Testimonies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Location\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Creation Date\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Name\n                      ")])])])
}]}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimonyLocation) ? _c('weather-card', {
    attrs: {
      "longitude": _vm.testimonyLocation.longitude,
      "latitude": _vm.testimonyLocation.latitude,
      "testimonyTime": _vm.testimonyTime
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.tweets), function(tweet) {
    return _c('tweet', {
      key: tweet.id,
      attrs: {
        "id": tweet.id,
        "options": {
          cards: 'hidden'
        }
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Automatic additional data")])])
}]}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-sm-offset-2"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "submit": "#"
    }
  }, [(!_vm.isCreation) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.$dirty && this.$v.previousPassword.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Previous Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previousPassword),
      expression: "previousPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.previousPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.previousPassword = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.$dirty && this.$v.password.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.$dirty && this.$v.confirmPassword.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default col-sm-offset-5",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger col-sm-offset-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("Create")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Password")])])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4"
  }, [_c('label', [_vm._v("Show\n                    "), _c('select', {
    staticClass: "form-control input-sm",
    on: {
      "change": _vm.onPageSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary new-btn col-sm-offset-1 col-sm-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showSubscriptionDialog()
      }
    }
  }, [_vm._v("New\n                  subscription\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_filter",
    attrs: {
      "id": "search_filter"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat btn-primary search-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'name'
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('name', 'true')
      }
    }
  }, [_vm._v("Name\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Subscribers")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'frequency'
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('frequency', 'true')
      }
    }
  }, [_vm._v("Frequency\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Area")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Subscription date\n                  ")]), _vm._v(" "), _c('th')])]), _vm._v(" "), (!_vm.subscriptions.length) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.subscriptions), function(subscription) {
    return _c('tr', {
      staticClass: "even clickable",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.showSubscriptionDialog(subscription)
        }
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(subscription.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subscription.emails.join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subscription.frequency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subscription.zone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("prettyDateTime")(subscription.creationDate)))]), _vm._v(" "), _c('td', {
      staticClass: "row-actions"
    }, [_c('i', {
      staticClass: "far fa-edit",
      attrs: {
        "title": "Edit"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-trash-alt",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteSubscription(subscription._id)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), (_vm.subscriptions.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("\n                Showing " + _vm._s(_vm.total - _vm.subscriptions.length + 1 > (_vm.page + 1) * _vm.size - 1 ? (_vm.page + 1) * _vm.size - 1 : _vm.total - _vm.subscriptions.length + 1) + "\n                to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.onPageChange,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('new-subscription-modal', {
    ref: "subscription-modal",
    attrs: {
      "id": "new-subscription-modal"
    },
    on: {
      "remove": _vm.deleteSubscription,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Subscriptions")])])
}]}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((this.markers && this.markers.length && this.markers[0]) || this.noEmptyMessage) ? _c('div', [_c('div', {
    attrs: {
      "id": "osm"
    }
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n  No coordinates available\n")])
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "submit": "#"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.user.$dirty && this.$v.user.username.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Mail")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "john.doe@wwow.com"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.user.$dirty && this.$v.user.lastName.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Doe"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.user.$dirty && this.$v.user.firstName.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Firstname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "John"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "radio col-sm-8"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    attrs: {
      "type": "radio",
      "value": "WWOW_USER"
    },
    domProps: {
      "checked": _vm._q(_vm.user.role, "WWOW_USER")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "role", "WWOW_USER")
      }
    }
  }), _vm._v("\n                Utilisateur\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-sm-offset-3 col-sm-8"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    attrs: {
      "type": "radio",
      "value": "WWOW_ADMIN"
    },
    domProps: {
      "checked": _vm._q(_vm.user.role, "WWOW_ADMIN")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "role", "WWOW_ADMIN")
      }
    }
  }), _vm._v("\n                Administrateur\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New User")])])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "far fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.notificationSize))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.notificationSize) + " notification(s)")]), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('li', {
      key: notification._id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Testimony',
          params: {
            id: notification._id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope text-wwow"
    }), _vm._v(" A new testimony has been reported\n                      ")])], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('p', {
    staticClass: "navbar-text"
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.demo.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), (_vm.user) ? _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Login',
        query: {
          logout: 'yes'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out-alt"
  }), _vm._v(" Logout\n              ")])], 1)])])])]), _vm._v(" "), (_vm.user) ? _c('sidebar', {
    attrs: {
      "role": _vm.user.role,
      "display-name": _vm.user.displayName,
      "picture-url": _vm.demo.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "page-nav"
  }, [(_vm.$route.name === 'Testimony' || _vm.$route.name === 'TestimonyHistory') ? _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-nav-item",
    class: {
      'active': _vm.$route.name === 'Testimony'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Testimony', _vm.$route.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-android-list"
  }), _vm._v(" Detail\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-nav-item",
    class: {
      'active': _vm.$route.name === 'TestimonyHistory'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('TestimonyHistory', _vm.$route.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-android-time"
  }), _vm._v(" History \n              ")])])]) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" HOME\n            ")])], 1), _vm._v(" "), (_vm.$route.meta.parentName) ? _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.meta.parentName
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$route.meta.parentName.toUpperCase()) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'Dashboard') ? _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$route.name.toUpperCase()) + "\n            ")])], 1) : _vm._e()])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "img-responsive center-block logo"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.link.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body col-lg-6"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.testimonies,
      "multiple": true,
      "track-by": "_id",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.link
    }
  }, [_vm._v("Confirm")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add one or more testimonies to the following case : ")])])
}]}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('users-list', {
    ref: "usersList",
    on: {
      "openModal": _vm.openModal
    }
  })], 1)])])])])]), _vm._v(" "), _c('new-user-modal', {
    attrs: {
      "id": "NewUserModal"
    },
    on: {
      "create": _vm.createUser
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Users")])])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-container vh-container"
  }, [_c('osm-map', {
    attrs: {
      "markers": this.markers,
      "noEmptyMessage": true,
      "search": true,
      "filters": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row dashboard-content"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Testimonies")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Cases")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.cases))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info-box box-orange info-box-with-progress"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Cases completed")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.casesCompletedRatio)), _c('small', [_vm._v("%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ('width:' + _vm.casesCompletedRatio + '%')
  })])])])])]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon box-orange"
  }, [_c('i', {
    staticClass: "ion ion-ios-paper-outline"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon box-orange"
  }, [_c('i', {
    staticClass: "ion ion-ios-filing-outline"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "ion ion-social-buffer-outline"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-wwow"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Monthly Testimonies Overview")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "trafficBar"
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "visible-xs-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Testimonies Gender Repartition")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "genderRepartition"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 top-space"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Worldwild Testimonies Localisation")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "world-map-markers"
    }
  })])])])])])])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4",
    attrs: {
      "id": "example1_length"
    }
  }, [_c('label', [_vm._v("Show\n                    "), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "name": "example1_length",
      "aria-controls": "example1"
    },
    on: {
      "change": _vm.showSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary new-btn col-sm-offset-1 col-sm-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("New case")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_filter",
    attrs: {
      "id": "example1_filter"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "placeholder": "Syria",
      "aria-controls": "example1"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "change": _vm.searchChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat btn-primary search-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row filters-row"
  }, [_c('div', {
    staticClass: "col-sm-12 filters"
  }, [_c('div', {
    staticClass: "card card-body"
  }, [_c('tags-search', {
    ref: "tags-search"
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Creation Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Platform(s): activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'testimonySize'
    },
    attrs: {
      "aria-label": "Engine version: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('testimonySize', 'true')
      }
    }
  }, [_vm._v("Testimonies size")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Creator")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Tags",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Tags")])])]), _vm._v(" "), (_vm.cases.length === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.cases), function(currentCase) {
    return _c('tr', {
      staticClass: "even clickable",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.goToCase(currentCase)
        }
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(currentCase.creationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.testimonySize))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.creatorName))]), _vm._v(" "), _c('td', _vm._l((_vm.tagsByCase[currentCase._id]), function(tag) {
      return _c('span', {
        staticClass: "label label-default",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.searchByTag(tag)
          }
        }
      }, [_vm._v(_vm._s(tag))])
    }), 0)])
  }), 0)])])]), _vm._v(" "), (_vm.cases.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "example1_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("Showing " + _vm._s(_vm.total - _vm.cases.length + 1 > (_vm.page + 1) * _vm.size - 1 ? (_vm.page + 1) * _vm.size - 1 : _vm.total - _vm.cases.length + 1) + " to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('new-case-modal', {
    attrs: {
      "id": "NewCaseModal"
    },
    on: {
      "create": _vm.createCase
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cases")])])
}]}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "timeline"
  }, [_vm._l((_vm.history), function(testimony, index) {
    return [_c('li', {
      staticClass: "time-label"
    }, [(testimony.updatedAt && (index === 0 || !_vm.sameDate(testimony.updatedAt, _vm.history[index - 1].updatedAt))) ? _c('span', {
      staticClass: "bg-orange"
    }, [_vm._v("\n              " + _vm._s(_vm._f("prettyDate")(testimony.updatedAt)) + "\n            ")]) : _vm._e(), _vm._v(" "), (!testimony.updatedAt) ? _c('span', {
      staticClass: "bg-orange"
    }, [_vm._v("\n              " + _vm._s(_vm._f("prettyDate")(testimony.creationDate)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "fa fa-envelope bg-red"
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-item"
    }, [(testimony.updatedAt) ? _c('span', {
      staticClass: "time"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm._f("prettyTime")(testimony.updatedAt)))]) : _vm._e(), _vm._v(" "), (!testimony.updatedAt) ? _c('span', {
      staticClass: "time"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm._f("prettyTime")(testimony.creationDate)))]) : _vm._e(), _vm._v(" "), (!testimony.updatedAt && testimony.victimIdentity) ? _c('h3', {
      staticClass: "timeline-header"
    }, [_c('strong', [_vm._v(_vm._s(testimony.purpose !== 'VICTIM' ? (testimony.witnessIdentity.name ? testimony.witnessIdentity.name : 'An anonymous person') : (testimony.victimIdentity.name ? testimony.victimIdentity.name : 'An anonymous person')))]), _vm._v(" has created the testimony as a " + _vm._s(testimony.purpose) + "\n          ")]) : _vm._e(), _vm._v(" "), (testimony.updatedAt && testimony.updatedBy) ? _c('h3', {
      staticClass: "timeline-header"
    }, [_c('strong', [_vm._v(_vm._s(testimony.updatedBy.firstName + ' ' + testimony.updatedBy.lastName) + " (" + _vm._s(testimony.updatedBy.role) + ")")]), _vm._v(" has updated the testimony\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "timeline-body"
    }, [_vm._l((_vm.customizeDiff(_vm.history[index], _vm.history[index + 1])), function(message) {
      return [_c('span', {
        domProps: {
          "innerHTML": _vm._s(message)
        }
      })]
    })], 2)])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/wwow-logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.victimCondition && this.victimCondition.injury) ? _c('div', {
    staticClass: "text-center"
  }, [(this.frontWounds.length || this.backWounds.length) ? [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row flex-row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(this.victimCondition.woundImage) ? _c('img', {
    staticClass: "img-thumbnail img-responsive",
    attrs: {
      "src": 'data:image/png;base64,' + this.victimCondition.woundImage,
      "alt": "Frontside injuries"
    }
  }) : _c('div', {
    staticClass: "caption"
  }, [_c('span', [_vm._v("No wounds")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(this.victimCondition.backWoundImage) ? _c('img', {
    staticClass: "img-thumbnail img-responsive",
    attrs: {
      "src": 'data:image/png;base64,' + this.victimCondition.backWoundImage,
      "alt": "Backside injuries"
    }
  }) : _c('div', {
    staticClass: "caption"
  }, [_c('span', [_vm._v("No wounds")])])])])] : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Victim injured - no wounds specified")])], 2) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Victim not injured")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row injuries-caption"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_c('strong', [_vm._v("Legend")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_c('span', {
    staticClass: "injury-type",
    staticStyle: {
      "background-color": "rgb(175, 36, 42)"
    }
  }), _vm._v(" "), _c('span', [_vm._v("External injuries")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "injury-type",
    staticStyle: {
      "background-color": "rgb(35, 31, 32)"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Internal injuries")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "injury-type",
    staticStyle: {
      "background-color": "rgb(105, 33, 37)"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Both internal and external injuries")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row details"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v("Frontside")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v("Backside")])])])
}]}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4",
    attrs: {
      "id": "example1_length"
    }
  }, [_c('label', [_vm._v("Show\n            "), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "name": "example1_length",
      "aria-controls": "example1"
    },
    on: {
      "change": _vm.showSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("New user")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "aria-label": "Creation date",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Creation Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Name",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Firstname",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Firstname")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Username",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Username",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.users.length === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user._id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(user.creationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.role))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-close clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Remove User"
      },
      on: {
        "click": function($event) {
          return _vm.confirmRemoveUser(user._id)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), (_vm.users.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "example1_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("Showing \n            " + _vm._s(_vm.total - _vm.users.length + 1 > _vm.page * _vm.size + 1 ? _vm.page * _vm.size + 1 : _vm.total - _vm.users.length + 1) + "\n            to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to delte this user ?",
      "title": "Delete Confirmation",
      "id": "ConfirmModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.remove()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Confirm")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('testimonies-list', {
    attrs: {
      "globalEnpoint": _vm.globalEnpoint,
      "searchEndpoint": _vm.searchEndpoint,
      "searchEnabled": _vm.searchEnabled,
      "additionalQueryParam": _vm.additionalQueryParam
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Testimonies")])])
}]}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body anchor",
    class: {
      'no-padding': _vm.anchors && _vm.anchors.length > 0
    }
  }, [_c('div', {
    staticClass: "anchor-button"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmAnchor
    }
  }, [_c('i', {
    staticClass: "ion ion-android-lock lock-icon"
  }), _vm._v(" Anchor now\n      ")])]), _vm._v(" "), (_vm.anchors.length == 0) ? _c('p', {
    staticClass: "anchor-label"
  }, [_vm._v("This item has not been anchored yet")]) : _vm._e(), _vm._v(" "), (_vm.anchors.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped no-margin",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.anchors), function(anchor) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("prettyDateTime")(anchor.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(anchor.anchoredBy.firstName) + " " + _vm._s(anchor.anchoredBy.lastName))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "file-name",
      attrs: {
        "href": _vm.getUrl(anchor)
      }
    }, [_c('i', {
      staticClass: "fa fa-file clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Download"
      }
    })])])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to secure and anchor this item ?",
      "title": "Secure Confirmation",
      "id": "ConfirmAnchorModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.anchor()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Anchors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "Achor Date",
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Anchor Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "User",
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "file",
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("File")])])])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MENU")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('dashboard') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('worldmap') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/worldmap"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Worldmap")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('testimonies') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/testimonies"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Testimonies")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('cases') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/cases"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cases")])])]), _vm._v(" "), (_vm.role === 'WWOW_ADMIN') ? _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('users') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/users"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Users")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('subscriptions') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/subscriptions"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Subscriptions")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm.currentCase) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.currentCase.name))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Delete"
    },
    on: {
      "click": _vm.confirm
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-link clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Link"
    },
    on: {
      "click": _vm.openLinkModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('testimonies-list', {
    ref: "testimoniesListRef",
    attrs: {
      "globalEnpoint": _vm.firstGlobalEnpoint,
      "searchEndpoint": _vm.firstSearchEndpoint,
      "searchEnabled": _vm.firstSearchEnabled,
      "additionalQueryParam": _vm.firstAdditionalQueryParam
    },
    on: {
      "loaded": _vm.onTestimoniesLoaded
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.currentCase) ? _c('signaletics', {
    attrs: {
      "id": _vm.id,
      "status": this.currentCase.status,
      "type": "cases"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.currentCase) ? _c('anchors', {
    attrs: {
      "id": _vm.id,
      "type": "cases",
      "anchorDone": "refresh"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('osm-map', {
    attrs: {
      "markers": _vm.testimoniesMarkers
    }
  })], 1)])])])]), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to archive this case ?",
      "title": "Archive Confirmation",
      "id": "ConfirmModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.archive()
      }
    }
  }), _vm._v(" "), _c('link-testimony-modal', {
    ref: "linkTestimonyModal",
    attrs: {
      "id": "LinkTestimonyModal",
      "preselected": _vm.testimonies
    },
    on: {
      "link": _vm.linkAll
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Testimonies localisation")])])
}]}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.name === true
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Case name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Syria - May 2018"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Case")])])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('sidebar-menu', {
    attrs: {
      "role": _vm.role
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    staticClass: "form-control capitalize",
    domProps: {
      "value": this.status
    },
    on: {
      "change": function($event) {
        return _vm.saveStatus($event)
      }
    }
  }, _vm._l((this.statusOptions), function(statusOption) {
    return _c('option', {
      staticClass: "capitalize",
      domProps: {
        "value": statusOption
      }
    }, [_vm._v(" " + _vm._s(statusOption.toLowerCase()) + " ")])
  }), 0)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10 new-tag-item"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Add new tag",
      "track-by": "name",
      "options": _vm.tagOptions,
      "multiple": true,
      "taggable": true,
      "custom-label": _vm.optionLabelFormatter,
      "closeOnSelect": false,
      "showLabels": false
    },
    on: {
      "tag": _vm.tagNameConverter
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedTags.length
    },
    on: {
      "click": _vm.saveTags
    }
  }, [_vm._v("\n              Add\n            ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tag-items"
  }, [(!_vm.associatedTags.length) ? [_c('p', [_vm._v("No associated tags")])] : _vm._e(), _vm._v(" "), (_vm.associatedTags.length) ? _vm._l((_vm.associatedTags), function(tag) {
    return _c('span', {
      staticClass: "tag-item",
      on: {
        "click": function($event) {
          return _vm.searchTag(tag.name)
        }
      }
    }, [_c('span', {
      staticClass: "label label-default"
    }, [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-close clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Remove tag"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeTag(tag)
        }
      }
    })])
  }) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Signaletics")])])
}]}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flex-row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.name
    }
  }, [_c('label', {
    staticClass: "col-sm-5 control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Optional"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.name) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.frequency
    }
  }, [_c('label', {
    staticClass: "col-sm-5 control-label",
    attrs: {
      "for": "frequency"
    }
  }, [_vm._v("Frequency")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frequency),
      expression: "frequency"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "frequency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.frequency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL"
    },
    domProps: {
      "selected": _vm.frequency === 'ALL'
    }
  }, [_vm._v("Instantly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DAILY"
    },
    domProps: {
      "selected": _vm.frequency === 'DAILY'
    }
  }, [_vm._v("Daily")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEEKLY"
    },
    domProps: {
      "selected": _vm.frequency === 'WEEKLY'
    }
  }, [_vm._v("Weekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MONTHLY"
    },
    domProps: {
      "selected": _vm.frequency === 'MONTHLY'
    }
  }, [_vm._v("Monthly")])]), _vm._v(" "), (_vm.errors.frequency) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.frequency))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.emails
    }
  }, [_c('label', {
    staticClass: "col-sm-5 control-label",
    attrs: {
      "for": "emails"
    }
  }, [_vm._v("Send to")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('multiselect', {
    attrs: {
      "id": "emails",
      "placeholder": "Add email",
      "options": _vm.emailsOptions,
      "limit": 10,
      "multiple": true,
      "taggable": true,
      "closeOnSelect": false,
      "showLabels": false
    },
    on: {
      "tag": _vm.tagEmailConverter
    },
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  }), _vm._v(" "), (_vm.errors.emails) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.emails))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.area
    }
  }, [_c('label', {
    attrs: {
      "for": "lmap"
    }
  }, [_vm._v("Geographic area")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "lmap"
    }
  }), _vm._v(" "), (_vm.errors.area) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.area))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.isUpdate) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.isUpdate) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), (_vm.isUpdate) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Subscription")])])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "weather"
    }
  }, [(!_vm.error) ? _c('div', {
    attrs: {
      "id": "display"
    }
  }, [_c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.location))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("prettyDate")(_vm.testimonyTime)))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.summary))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "left-information"
    }
  }, [_c('img', {
    staticClass: "thumbnail",
    attrs: {
      "src": _vm.getThumbnail(_vm.status, 64),
      "alt": _vm.status
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "temperature"
  }, [_vm._v(_vm._s(_vm.temperature))]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "right-information"
    }
  }, [_c('span', [_vm._v("Humidity: " + _vm._s(_vm.humidity) + "%")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pressure: " + _vm._s(_vm.pressure) + " mb")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Wind speed: " + _vm._s(_vm.wind) + " km/h")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "forecast"
    }
  })]) : _c('div', [_vm._v("Location ID error")])])
},staticRenderFns: []}

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[237]);


// WEBPACK FOOTER //
// static/js/app.bac14042d820508a8db6.js